export default {
  "nav_signin": "Iniciar sesión",
  "nav_account": "Cuenta",
  "nav_signout": "Cerrar sesión",
  "hero_title": "Soluciones Digitales Inteligentes",
  "hero_title_line1": "Infinity Business — Soluciones",
  "hero_title_line2": "Digitales Inteligentes",
  "hero_subtitle": "Conoce a RisTA, tu socio digital inteligente",
  "hero_cta": "Hablar con RisTA",
  "hero_cta2": "Ver servicios",
  "b2b_title": "Soluciones Empresariales (B2B)",
  "p2p_title": "Soluciones Personales (P2P)",
  "b2b_desc": "Web, móvil, software, hosting, diseño y publicidad",
  "p2p_desc": "Educación cripto, herramientas de inversión, organización, traducción, branding, dominios",
  "services_title": "Nuestros Servicios",
  "services_subtitle": "Desde soluciones web empresariales hasta herramientas de inversión personal. RisTA te guía.",
  "cta_title": "¿Listo para crear algo increíble?",
  "cta_subtitle": "Habla con RisTA para obtener un presupuesto personalizado en minutos.",
  "about": "Acerca de",
  "contact": "Contacto",
  "privacy": "Privacidad",
  "blog": "Blog",
  "donate": "Donar",
  "booking": "Reservar sesión",
  "login_title": "Bienvenido de nuevo",
  "register_title": "Crear cuenta",
  "login_subtitle": "Inicia sesión en tu cuenta de Infinity Business",
  "register_subtitle": "Únete a Infinity Business hoy",
  "auth0_btn": "Continuar con Auth0",
  "or_email": "o continuar con email",
  "email": "Correo electrónico",
  "password": "Contraseña",
  "full_name": "Nombre completo",
  "signin_btn": "Iniciar sesión",
  "register_btn": "Crear cuenta",
  "no_account": "¿No tienes cuenta?",
  "have_account": "¿Ya tienes cuenta?",
  "create_one": "Crear una",
  "sign_in": "Iniciar sesión",
  "pricing_title": "Elige tu plan",
  "pricing_subtitle": "Todos los planes incluyen acceso a RisTA.",
  "pay_stripe": "Pagar con Stripe",
  "pay_mypos": "Pagar con myPOS",
  "pay_crypto": "Pagar con Cripto",
  "free_plan": "Plan gratuito actual",
  "most_popular": "Más popular",
  "dashboard_title": "Mi cuenta",
  "profile": "Perfil",
  "security": "Seguridad (2FA)",
  "subscription": "Suscripción",
  "upgrade": "Mejorar",
  "change_plan": "Cambiar plan",
  "twofa_title": "Autenticación de dos factores",
  "setup_2fa": "Configurar 2FA",
  "disable_2fa": "Desactivar 2FA",
  "payment_success": "¡Pago exitoso!",
  "payment_cancel": "Pago cancelado",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. Todos los derechos reservados.",
  "about_title": "Sobre Infinity Business",
  "contact_title": "Contáctanos",
  "privacy_title": "Política de privacidad",
  "send_message": "Enviar mensaje",
  "trade_title": "Operamos por ti",
  "trade_desc": "Servicios profesionales de trading crypto. Chatea con nosotros.",
  "back_home": "Volver al inicio",
  "loading": "Cargando...",
  "save": "Guardar",
  "session_expired": "Tu sesión ha expirado. Por favor inicia sesión de nuevo.",
  "nav_services": "Servicios",
  "nav_portal": "Portal",
  "nav_credits": "Créditos",
  "hero_online": "En línea",
  "hero_digital_partner": "Socio digital",
  "business_solutions": "Soluciones empresariales",
  "personal_solutions": "Soluciones personales",
  "enterprise_desc": "Servicios digitales profesionales para hacer crecer su negocio.",
  "personal_desc": "Herramientas inteligentes de inversión y educación para el crecimiento personal.",
  "services_hero_title": "Nuestros servicios",
  "services_hero_desc": "Desde sitios web básicos hasta soluciones avanzadas de IA. Entregamos excelencia digital.",
  "get_started": "Empezar",
  "get_a_quote": "Obtener presupuesto",
  "free_seo_audit": "Auditoría SEO gratuita",
  "ready_to_start": "¿Listo para empezar?",
  "ready_to_build": "¿Listo para crear algo increíble?",
  "ready_to_build_sub": "Habla con RisTA para un presupuesto personalizado.",
  "trusted_worldwide": "Confianza mundial",
  "chat_placeholder": "Escribe tu mensaje...",
  "chat_suggested_1": "Necesito un sitio web",
  "chat_suggested_2": "Cuéntame sobre los servicios",
  "chat_suggested_3": "Quiero un servicio inteligente",
  "chat_suggested_4": "Obtener presupuesto",
  "trust_platform": "Plataforma confiable",
  "trust_security": "Seguridad empresarial",
  "trust_ai": "Tecnología Inteligente",
  "trust_global": "Alcance global",
  "back_to_home": "Volver al inicio",
  "continue_google": "Continuar con Google",
  "continue_facebook": "Continuar con Facebook",
  "continue_github": "Continuar con GitHub",
  "or_continue_email": "o continuar con email",
  "two_factor_auth": "Autenticación de dos factores",
  "enter_2fa_code": "Ingrese el código de su aplicación de autenticación",
  "verify_btn": "Verificar código",
  "verifying": "Verificando...",
  "use_different_account": "Usar otra cuenta",
  "session_expired_msg": "Su sesión ha expirado por inactividad. Inicie sesión de nuevo.",
  "nav_home": "Inicio",
  "nav_back": "Volver",
  "my_account": "Mi cuenta",
  "sign_out": "Cerrar sesión",
  "client_portal": "Portal de clientes",
  "your_projects": "Sus proyectos",
  "your_invoices": "Sus facturas",
  "projects": "Proyectos",
  "invoices_tab": "Facturas",
  "milestones": "Hitos",
  "messages": "Mensajes",
  "no_projects": "Aún no hay proyectos.",
  "no_invoices": "Aún no hay facturas.",
  "no_messages": "Aún no hay mensajes. Inicie una conversación.",
  "type_message": "Escriba un mensaje...",
  "back_to_projects": "Volver a proyectos",
  "budget_label": "Presupuesto",
  "progress_label": "Progreso",
  "service_label": "Servicio",
  "portal_locked_desc": "El portal está disponible para clientes aprobados.",
  "contact_to_start": "Contáctenos para comenzar",
  "quick_web_dev": "Desarrollo web",
  "quick_mobile": "App móvil",
  "quick_crypto": "Educación cripto",
  "quick_get_quote": "Obtener presupuesto",
  "quick_tell_more": "Cuénteme más",
  "quick_have_project": "Tengo un proyecto",
  "quick_submit": "Enviar solicitud",
  "get_cost_estimate": "Estimación de costos",
  "choose_plan": "Elija su plan",
  "choose_plan_desc": "Escale su negocio con el plan correcto.",
  "current_free_plan": "Plan gratuito actual",
  "svc_ecommerce_label": "E-Commerce / Tienda online",
  "svc_ecommerce_desc": "Tiendas online completas con integración de pagos",
  "svc_seo_label": "SEO y marketing digital",
  "svc_seo_desc": "Optimización en buscadores y estrategia de crecimiento",
  "svc_hosting_label": "Hosting gestionado",
  "svc_hosting_desc": "Infraestructura de hosting segura, rápida y fiable",
  "svc_advertising_label": "Publicidad digital",
  "svc_advertising_desc": "PPC, anuncios sociales y marketing de rendimiento",
  "svc_trading_label": "Consultoría de trading",
  "svc_trading_desc": "Sesiones de estrategia de trading guiadas por expertos",
  "svc_domains_label": "Gestión de dominios",
  "svc_domains_desc": "Registro de dominios, gestión DNS y transferencias",
  "svc_ecommerce_price": "Desde €799",
  "svc_seo_price": "Desde €299/mes",
  "svc_hosting_price": "Desde €29/mes",
  "svc_advertising_price": "Desde €499/mes",
  "svc_trading_price": "Desde €149/sesión",
  "svc_domains_price": "Desde €19/año",
  "testimonials_title": "Lo que dicen nuestros clientes",
  "testimonials_subtitle": "Empresas de toda Europa confían en nosotros",
  "stat_projects": "Proyectos entregados",
  "stat_satisfaction": "Satisfacción del cliente",
  "stat_languages": "Idiomas soportados",
  "all_rights_reserved": "Todos los derechos reservados.",
  "form_your_name": "Tu nombre",
  "form_your_email": "Tu email",
  "form_describe_need": "Describe lo que necesitas...",
  "form_additional_feedback": "¿Comentarios adicionales? (opcional)",
  "form_email_followup": "Tu email (opcional, para seguimiento)",
  "form_budget_range": "Rango de presupuesto",
  "form_timeline": "Plazo",
  "form_cancel": "Cancelar",
  "form_select_services": "Selecciona servicios (varios posibles):",
  "rating_title": "Califica tu experiencia con RisTA",
  "rating_helpful": "¿Qué tan útil fue esta conversación?",
  "rating_overall": "Experiencia general con el asistente",
  "rating_recommend": "¿Recomendarías RisTA?",
  "rating_yes": "Sí",
  "rating_no": "No",
  "rating_submit": "Enviar calificación",
  "rating_skip": "Omitir",
  "rating_thanks": "¡Gracias por tus comentarios!",
  "generating_estimate": "Generando estimación de costos...",
  "profile_info": "Información del perfil",
  "profile_name": "Nombre",
  "profile_email": "Correo",
  "profile_role": "Rol",
  "profile_member_since": "Miembro desde",
  "profile_rerun_onboarding": "Repetir introducción",
  "profile_language_pref": "Idioma preferido",
  "profile_language_saved": "¡Preferencia de idioma guardada!",
  "privacy_heading": "Política de privacidad",
  "terms_heading": "Términos y condiciones",
  "about_heading": "Sobre Infinity Business",
  "walkthrough_heading": "Tutoriales",
  "nav_tools": "Herramientas",
  "nav_marketplace": "Mercado",
  "chat_digital_partner": "Socio digital",
  "chat_online": "En línea",
  "chat_help_text": "Puedo ayudar con desarrollo web, apps móviles, diseño, cripto y más.",
  "chat_your_partner": "Tu socio digital",
  "chat_assistant_subtitle": "Chatea con tu asistente IA",
  "tab_password": "Contraseña",
  "tab_rista_services": "Servicios RisTA",
  "tab_analytics": "Analíticas",
  "tab_projects": "Proyectos",
  "tab_referral": "Programa de referidos",
  "marketplace_title": "Mercado de plantillas",
  "marketplace_subtitle": "Plantillas premium personalizables. Calidad profesional, listas para usar.",
  "marketplace_search": "Buscar plantillas...",
  "marketplace_purchase": "Comprar",
  "marketplace_preview": "Vista previa",
  "marketplace_all": "Todos",
  "marketplace_category_website": "Sitio web",
  "marketplace_category_brand": "Marca",
  "marketplace_category_resume": "Currículum",
  "marketplace_downloads": "descargas",
  "marketplace_features": "Características",
  "case_studies_title": "Historias de éxito",
  "case_studies_subtitle": "Resultados reales de negocios reales. Vea la transformación.",
  "case_studies_before": "Antes",
  "case_studies_after": "Después",
  "case_studies_cta_title": "¿Listo para hacer crecer tu negocio?",
  "case_studies_cta_desc": "Únete a estos negocios y obtén resultados similares con nuestros servicios de IA.",
  "case_studies_cta_btn": "Comenzar",
  "profile_go_homepage": "Ir a la página principal",
  "onboarding_welcome_title": "Bienvenido a Infinity Business",
  "onboarding_welcome_subtitle": "Tu socio digital impulsado por IA",
  "onboarding_welcome_content": "Infinity Business ofrece servicios digitales B2B y P2P. Nuestro asistente IA RisTA te guiará.",
  "onboarding_welcome_item1": "Estimación de proyectos con IA",
  "onboarding_welcome_item2": "Servicios web, móvil y diseño",
  "onboarding_welcome_item3": "Educación cripto y herramientas de inversión",
  "onboarding_welcome_item4": "Consultas personalizadas",
  "onboarding_services_title": "Explora nuestros servicios",
  "onboarding_services_subtitle": "Dos categorías para ti",
  "onboarding_services_content": "Ofrecemos dos categorías de servicios:",
  "onboarding_services_item1": "B2B: Desarrollo web, apps móviles, diseño gráfico, hosting, software, publicidad",
  "onboarding_services_item2": "P2P: Educación cripto, herramientas de inversión, trading, dominios, DeFi",
  "onboarding_services_item3": "Servicios IA: Currículum, plan de negocios, informes SEO, kits de marca y más",
  "onboarding_services_item4": "Habla con RisTA en cualquier momento para una cotización personalizada",
  "onboarding_credits_title": "Sistema de créditos",
  "onboarding_credits_subtitle": "Saldo prepago para servicios IA",
  "onboarding_credits_content": "Usa créditos para acceso instantáneo a nuestros servicios IA:",
  "onboarding_credits_item1": "Recarga tu saldo en cualquier momento (mín. 5, máx. 1.000)",
  "onboarding_credits_item2": "Los créditos se deducen automáticamente al usar servicios IA",
  "onboarding_credits_item3": "Siempre se te pedirá confirmación antes de cualquier deducción",
  "onboarding_credits_item4": "Ve tu saldo e historial en el panel de créditos",
  "onboarding_chat_title": "Habla con RisTA",
  "onboarding_chat_subtitle": "Tu socio digital está listo",
  "onboarding_chat_content": "RisTA puede ayudarte con:",
  "onboarding_chat_item1": "Obtener estimaciones y cotizaciones de proyectos",
  "onboarding_chat_item2": "Explorar opciones de servicios en detalle",
  "onboarding_chat_item3": "Enviar solicitudes de servicio",
  "onboarding_chat_item4": "Responder preguntas en 11 idiomas",
  "onboarding_next": "Siguiente",
  "onboarding_get_started": "Comenzar",
  "onboarding_back": "Atrás",
  "onboarding_biz_title": "Selección de servicios",
  "onboarding_biz_subtitle": "¿Qué describe mejor tus necesidades?",
  "onboarding_biz_content": "Ayúdanos a recomendarte los servicios adecuados:",
  "onboarding_biz_type_startup": "Startup / Nuevo negocio",
  "onboarding_biz_type_smb": "Pequeña-Mediana empresa",
  "onboarding_biz_type_enterprise": "Gran empresa / Corporación",
  "onboarding_biz_type_freelancer": "Freelancer / Particular",
  "onboarding_biz_type_investor": "Inversor / Entusiasta cripto",
  "change_password_title": "Cambiar contraseña",
  "referral_title": "Programa de referidos",
  "referral_generate": "Generar mi código de referido",
  "referral_redeem_title": "Canjear un código",
  "referral_redeem_btn": "Canjear",
  "referral_referrals": "Referidos",
  "referral_rewards": "Recompensas",
  "referral_copy_link": "Copiar enlace",
  "referral_copied": "¡Copiado!",
  "project_tracker_title": "Seguimiento de proyectos",
  "project_no_projects": "Aún no hay proyectos. Aparecerán aquí después de comprar un servicio.",
  "analytics_total_services": "Total de servicios",
  "analytics_completed": "Completados",
  "analytics_pending": "Pendientes",
  "analytics_total_spent": "Total gastado",
  "analytics_credit_balance": "Saldo de créditos",
  "analytics_recent": "Servicios recientes",
  "billing_manage_btn": "Gestionar facturación",
  "billing_cancel_btn": "Cancelar plan",
  "plan_features": "Características de tu plan",
  "nav_try_free": "Prueba gratis",
  "testimonial_1_text": "RisTA nos ayudó a construir toda nuestra presencia web en solo 2 semanas.",
  "testimonial_2_text": "El kit de marca y el calendario de redes sociales nos ahorraron meses de trabajo.",
  "testimonial_3_text": "Uso regularmente el creador de CV y las herramientas de análisis. La calidad de IA es excelente.",
  "services_cta_title": "Listo para empezar?",
  "services_cta_desc": "Habla con RisTA, nuestro asistente digital inteligente, para obtener un presupuesto personalizado.",
  "services_talk_rista": "Hablar con RisTA",
  "services_free_audit": "Auditoria SEO gratuita",
  "tools_title": "Herramientas de marketing gratuitas",
  "tools_subtitle": "Prueba nuestras herramientas gratuitas - sin registro",
  "sp_basic_web_name": "Creacion de sitio web basico",
  "sp_basic_web_desc": "Sitio web profesional para tu negocio con diseno moderno y compatibilidad movil completa.",
  "sp_basic_web_feat": "Diseno responsive moderno|Hasta 5 paginas|Integracion de formulario de contacto|Optimizado para movil|Configuracion SEO basica|Asistencia en la carga de contenido",
  "sp_web_store_name": "Tienda online / E-Commerce",
  "sp_web_store_desc": "Plataforma e-commerce completa con pagos integrados y herramientas de marketing.",
  "sp_web_store_feat": "Tienda online completa|Procesamiento de pagos|Gestion de productos|Seguimiento de pedidos|Optimizacion SEO|Estrategia de marketing incluida",
  "sp_custom_web_name": "Aplicacion web personalizada",
  "sp_custom_web_desc": "Aplicaciones web adaptadas a los requisitos exactos de tu negocio.",
  "sp_custom_web_feat": "Diseno de software personalizado|Integraciones API|Arquitectura de base de datos|Infraestructura escalable|Paneles de administracion|Soporte continuo",
  "sp_mobile_app_name": "Aplicacion movil",
  "sp_mobile_app_desc": "Aplicaciones moviles nativas y multiplataforma para iOS y Android.",
  "sp_mobile_app_feat": "iOS y Android|Desarrollo multiplataforma|Notificaciones push|Envio a tiendas de apps|Diseno UI/UX|Integracion backend",
  "sp_seo_name": "SEO y marketing digital",
  "sp_seo_desc": "Aumenta tu visibilidad online con estrategias integrales de SEO y marketing digital.",
  "sp_seo_feat": "Auditoria SEO completa|Optimizacion de palabras clave|Estrategia de contenido|Gestion de Google Ads|Marketing en redes sociales|Informes mensuales",
  "sp_graphic_name": "Diseno grafico y branding",
  "sp_graphic_desc": "Soluciones completas de branding y diseno grafico para la identidad de tu negocio.",
  "sp_graphic_feat": "Diseno de logo|Identidad de marca|Materiales de marketing|Graficos para redes sociales|Diseno de impresion|Guia de estilo",
  "sp_crypto_edu_name": "Programa de educacion cripto",
  "sp_crypto_edu_desc": "Aprende trading de criptomonedas y tecnologia blockchain con expertos de la industria.",
  "sp_crypto_edu_feat": "Fundamentos de blockchain|Estrategias de trading|Seguridad de billeteras|Introduccion a DeFi|Analisis de mercado|Mentoria personal",
  "sp_invest_name": "Herramientas de inversion inteligentes",
  "sp_invest_desc": "Herramientas profesionales de seguimiento y analisis de inversiones con IA.",
  "sp_invest_feat": "Seguimiento de portafolio|Panel de mercado|Analisis con IA|Evaluacion de riesgos|Alertas en tiempo real|Soporte multi-exchange",
  "sp_ad_name": "Servicios de publicidad",
  "sp_ad_desc": "Llega a millones a traves de nuestra extensa red de portales en multiples regiones.",
  "sp_ad_feat": "Red de 20+ portales|10M+ de alcance|Campanas dirigidas|Seguimiento de rendimiento|Anuncios multi-plataforma|Optimizacion de ROI",
  "contact_heading": "Contactanos",
  "contact_subtitle_text": "Tienes una pregunta o quieres discutir un proyecto? Nos encantaria escucharte.",
  "contact_name_label": "Nombre",
  "contact_email_label": "Correo electronico",
  "contact_subject_label": "Asunto",
  "contact_message_label": "Mensaje",
  "contact_name_ph": "Tu nombre",
  "contact_email_ph": "tu@ejemplo.com",
  "contact_subject_ph": "De que se trata?",
  "contact_message_ph": "Cuentanos sobre tu proyecto o pregunta...",
  "contact_send_btn": "Enviar mensaje",
  "contact_sending": "Enviando...",
  "contact_sent_title": "Mensaje enviado!",
  "contact_sent_msg": "Gracias por contactarnos. Te responderemos en 24 horas.",
  "contact_send_another": "Enviar otro mensaje",
  "contact_info_email": "Correo",
  "contact_info_location": "Ubicacion",
  "contact_info_eu": "Union Europea",
  "contact_info_response": "Tiempo de respuesta",
  "contact_info_response_time": "Dentro de 24 horas",
  "contact_info_hours": "Lun - Vie, 9:00 - 18:00 CET",
  "tf_seo_name": "Auditoria SEO gratuita",
  "tf_seo_desc": "Obten un analisis SEO completo de cualquier sitio web - sin registro.",
  "tf_color_name": "Generador de paleta de colores",
  "tf_color_desc": "Genera paletas de colores hermosas y armoniosas para tu marca.",
  "tf_headline_name": "Analizador de titulares",
  "tf_headline_desc": "Evalua tus titulares para el potencial de clics e impacto emocional.",
  "tf_chat_name": "Chatea con RisTA",
  "tf_chat_desc": "Obten estimaciones de proyectos instantaneas y explora servicios en 11 idiomas.",
  "tf_free_label": "Gratis",
  "tools_seo_title": "Verificacion SEO rapida",
  "tools_seo_desc": "Puntuacion SEO instantanea para cualquier sitio",
  "tools_seo_ph": "Ingresa la URL del sitio (ej. ejemplo.com)",
  "tools_analyze": "Analizar",
  "tools_color_title": "Generador de paleta de colores",
  "tools_color_desc": "Genera paletas de colores complementarias",
  "tools_headline_title": "Analizador de titulares",
  "tools_headline_desc": "Analiza la efectividad de los titulares",
  "tools_headline_ph": "Ingresa tu titular...",
  "tools_headline_btn": "Analizar titular",
  "tools_issues": "Problemas encontrados",
  "tools_suggestions": "Sugerencias",
  "tools_score": "Puntuacion",
  "docs_heading": "Caracteristicas de la plataforma",
  "docs_subtitle": "Todo lo que Infinity Business ofrece para tu viaje digital.",
  "docs_no_data": "No hay documentacion disponible.",
  "tester_heading": "Conviertete en tester",
  "tester_subtitle": "Ayudanos a mejorar la plataforma y obtener acceso gratuito a los servicios.",
  "tester_req_title": "Lo que se requiere",
  "tester_req_1": "Iniciar sesion al menos 5 veces por semana",
  "tester_req_2": "Enviar al menos 10 informes de errores/comentarios por semana",
  "tester_req_3": "Probar diferentes funciones, paginas y flujos de usuario",
  "tester_benefit_title": "Lo que obtienes",
  "tester_benefit_1": "Acceso gratuito a servicios del sistema inteligente (bajo solicitud)",
  "tester_benefit_2": "Panel de tester con seguimiento de progreso",
  "tester_benefit_3": "Soporte prioritario del equipo",
  "tester_apply_title": "Postularse",
  "tester_motivation": "Por que quieres ser tester?",
  "tester_motivation_ph": "Cuentanos por que te gustaria ayudar a probar la plataforma...",
  "tester_experience": "Experiencia en pruebas (opcional)",
  "tester_experience_ph": "Cualquier experiencia relevante...",
  "tester_submit_app": "Enviar solicitud",
  "tester_applied_title": "Solicitud enviada",
  "tester_applied_msg": "Nuestro admin revisara tu solicitud y seras notificado.",
  "tester_need_account": "Necesitas una cuenta para postularte.",
  "tester_dash_title": "Panel de tester",
  "tester_dash_desc": "Manten tu estado de tester activo cumpliendo los objetivos semanales.",
  "tester_weekly_logins": "Inicios de sesion semanales",
  "tester_weekly_reports": "Informes semanales",
  "tester_target_met": "Objetivo alcanzado!",
  "tester_logins_needed": "inicios de sesion mas necesarios esta semana",
  "tester_reports_needed": "informes mas necesarios esta semana",
  "tester_total_reports": "Total de informes enviados",
  "tester_on_track": "En camino",
  "tester_at_risk": "En riesgo",
  "tester_report_heading": "Enviar informe de error / comentario",
  "tester_report_title_ph": "Titulo (ej. 'Boton no funciona en movil')",
  "tester_report_desc_ph": "Describe el problema o sugerencia en detalle...",
  "tester_report_page_ph": "URL de la pagina (opcional)",
  "tester_submit_report": "Enviar informe",
  "seo_page_title": "Auditoria SEO gratuita",
  "seo_page_desc": "Ingresa cualquier URL para un analisis SEO completo con recomendaciones.",
  "seo_page_ph": "Ingresa la URL del sitio (ej. ejemplo.com)",
  "seo_page_btn": "Ejecutar auditoria",
  "seo_page_running": "Analizando...",
  "seo_page_error": "No se pudo auditar este sitio. Verifica la URL e intenta de nuevo.",
  "referral_reward_title": "Como funcionan las recompensas",
  "referral_reward_desc": "Gana el 10% de cada compra realizada por usuarios que refieras, acreditado automaticamente como creditos gratuitos.",
  "referral_reward_1": "Comparte tu enlace de referido unico con amigos",
  "referral_reward_2": "Cuando realizan una compra, ganas 10% como creditos gratuitos",
  "referral_reward_3": "Los creditos se agregan automaticamente a tu saldo",
  "referral_earned_label": "Creditos ganados",
  "profile_picture": "Foto de perfil",
  "profile_bio": "Biografia",
  "profile_website": "Sitio web",
  "profile_interests": "Intereses",
  "profile_upload_photo": "Subir foto",
  "profile_bio_ph": "Cuentanos sobre ti...",
  "profile_website_ph": "https://tusitio.com",
  "profile_interests_ph": "ej. Desarrollo web, Cripto, IA",
  "profile_save": "Guardar perfil",
  "admin_notes": "Notas de admin",
  "admin_notes_ph": "Agregar nota sobre este usuario...",
  "admin_notes_add": "Agregar nota",
  "sub_most_popular": "Más popular",
  "sub_free": "Gratis",
  "sub_one_time": "pago único",
  "sub_team_members": "Miembros del equipo",
  "sub_members_info": "Invite miembros del equipo a compartir su plan. Cada miembro obtiene su propio inicio de sesión y acceso a servicios bajo su suscripción.",
  "sub_show_less": "Mostrar menos",
  "sub_more_features": "más funciones",
  "sub_pay_with": "Pagar con",
  "sub_preferred": "preferido",
  "sub_live_crypto": "Precios cripto en vivo (EUR y USD)",
  "sp_logo_name": "Diseño de Logo",
  "sp_logo_desc": "Diseño de logo profesional personalizado que captura la esencia de tu marca.",
  "sp_logo_feat": "3 conceptos únicos|Revisiones ilimitadas|Archivos vectoriales|Color + B/N|Directrices de marca|Kit redes sociales",
  "sp_brand_name": "Identidad de Marca Completa",
  "sp_brand_desc": "Paquete completo de identidad de marca con logo, paleta de colores y directrices.",
  "sp_brand_feat": "Diseño de logo|Paleta de colores|Tipografía|Tarjeta de visita|Papelería|PDF directrices|Plantillas redes sociales",
  "sp_poster_name": "Diseño de Póster",
  "sp_poster_desc": "Diseños de póster llamativos para eventos y campañas publicitarias.",
  "sp_poster_feat": "Ilustración personalizada|Archivos listos para imprimir|Varios tamaños|2 rondas de revisión|Alta resolución|Digital + impresión",
  "sp_flyer_name": "Diseño de Flyer",
  "sp_flyer_desc": "Diseños de flyer profesionales para marketing y eventos.",
  "sp_flyer_feat": "Diseño frontal y trasero|PDF para imprimir|Versión digital|Código QR|2 revisiones|Varios formatos",
  "sp_menu_name": "Diseño de Menú",
  "sp_menu_desc": "Hermosos diseños de menú para restaurantes y cafeterías.",
  "sp_menu_feat": "Diseño personalizado|Integración de fotos|Versión QR|Archivos para imprimir|Actualización estacional|Varias páginas",
  "currency_label": "Moneda",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "about_intro": "Somos una empresa tecnológica enfocada en soluciones digitales inteligentes. Fundada en 2026, Infinity Business combina innovación en IA con experiencia probada para ayudar a empresas e individuos.",
  "about_values": "Nuestros Valores",
  "about_what_we_do": "Qué Hacemos",
  "about_meet_rista": "Conoce a RisTA",
  "about_rista_desc": "RisTA es nuestro asistente inteligente de IA, impulsado por los últimos modelos. Ayuda a calificar requisitos, ofrece orientación instantánea y te conecta con nuestro equipo. Disponible 24/7, multilingüe.",
  "about_talk_rista": "Hablar con RisTA",
  "about_val_trust": "Confianza y Seguridad",
  "about_val_trust_desc": "Empleamos los más altos estándares de protección de datos.",
  "about_val_innovation": "Innovación",
  "about_val_innovation_desc": "Tecnología de IA de vanguardia impulsa nuestras soluciones.",
  "about_val_partnership": "Asociación",
  "about_val_partnership_desc": "Trabajamos junto a usted como un verdadero socio.",
  "about_val_global": "Alcance Global",
  "about_val_global_desc": "Nuestras soluciones están diseñadas para mercados internacionales.",
  "about_svc_web": "Desarrollo Web",
  "about_svc_web_desc": "Aplicaciones web, plataformas e-commerce y soluciones CMS.",
  "about_svc_mobile": "Aplicaciones Móviles",
  "about_svc_mobile_desc": "Apps nativas y multiplataforma para iOS y Android.",
  "about_svc_software": "Software Personalizado",
  "about_svc_software_desc": "Soluciones de software a medida para automatizar sus procesos.",
  "about_svc_invest": "Inversiones Inteligentes",
  "about_svc_invest_desc": "Herramientas de cripto y DeFi con IA y servicios profesionales de trading.",
  "micro_tools_title": "Micro-herramientas IA",
  "micro_tools_subtitle": "Información instantánea por IA para generación de leads e investigación de mercado.",
  "micro_tools_all": "Todas",
  "micro_tools_try": "Probar",
  "micro_tools_generate_free": "Generar (Gratis)",
  "micro_tools_generate_paid": "Generar",
  "micro_tools_close": "Cerrar",
  "micro_tools_interested": "¿Interesado?",
  "tools_view_service": "Ver servicio",
  "tools_talk_rista": "Hablar con RisTA",
  "competitor_title": "Análisis de competencia IA",
  "competitor_desc": "Ingrese URL del competidor para análisis IA con comparación SEO y revisión de diseño.",
  "competitor_url_ph": "Ingrese URL del competidor",
  "competitor_analyze": "Analizar competidor",
  "competitor_score": "Puntuación general",
  "competitor_seo": "Análisis SEO",
  "competitor_design": "Análisis de diseño",
  "competitor_content": "Análisis de contenido",
  "competitor_strengths": "Fortalezas",
  "competitor_weaknesses": "Debilidades",
  "competitor_opportunities": "Oportunidades",
  "competitor_recommendations": "Recomendaciones",
  "accessibility_title": "Verificación de accesibilidad",
  "accessibility_desc": "Verificar estándares de accesibilidad",
  "cat_lead_gen": "Lead-Gen y tráfico",
  "cat_discovery": "Descubrimiento de informes",
  "cat_email": "Email y flujo de trabajo",
  "cat_planning": "Planificación y estrategia",
  "cat_content": "Contenido y posicionamiento",
  "sp_tools_title": "Micro-servicios Inteligentes",
  "sp_tools_desc": "Servicios inteligentes instantáneos para contenido, marca, análisis y documentos.",
  "sp_free_title": "Herramientas Gratuitas",
  "sp_free_desc": "Prueba nuestra plataforma con estas herramientas gratuitas.",
  "a11y_checker": "Verificación de accesibilidad",
  "a11y_compliant": "Conforme",
  "a11y_disclaimer": "Las verificaciones automáticas cubren ~30% de los problemas de accesibilidad. Se recomienda realizar pruebas manuales.",
  "a11y_error": "La auditoría falló. Inténtelo de nuevo.",
  "a11y_incomplete": "necesita revisión",
  "a11y_issues_found": "Problemas encontrados",
  "a11y_no_issues": "¡No se encontraron problemas de accesibilidad!",
  "a11y_passed": "aprobado",
  "a11y_rescan": "Volver a escanear",
  "a11y_scanning": "Ejecutando auditoría WCAG...",
  "a11y_violations": "violaciones",
  "admin_ab_testing": "Pruebas A/B",
  "admin_account_mgmt": "Gestión de cuentas",
  "admin_actions": "Acciones",
  "admin_active": "Activo",
  "admin_ad_gen": "Generador de anuncios",
  "admin_add_milestone": "Agregar hito",
  "admin_adv_reports": "Informes avanzados",
  "admin_ai_config": "Configuración del modelo",
  "admin_ai_prompts": "Prompts inteligentes",
  "admin_analytics": "Analítica",
  "admin_audit": "Auditoría de plataforma",
  "admin_audit_trail": "Registro de auditoría",
  "admin_auto_posting": "Publicación automática inteligente",
  "admin_avatar_builder": "Constructor de avatar",
  "admin_avatar_selector": "Selector de avatar",
  "admin_avg_exp": "Exp. promedio",
  "admin_avg_rating": "Calificación promedio",
  "admin_backup": "Copia de seguridad",
  "admin_billing": "Facturación recurrente",
  "admin_blog": "Gestor de blog",
  "admin_bug_reports": "Reportes de errores",
  "admin_cancel": "Cancelar",
  "admin_cdn": "Gestor CDN",
  "admin_chat_analytics": "Analítica del chat",
  "admin_chat_sessions": "Sesiones de chat",
  "admin_client_portal": "Portal de clientes",
  "admin_abandoned_carts": "Carritos abandonados",
  "rista_login_required": "Inicio de sesión requerido",
  "rista_login_desc": "Inicie sesión o cree una cuenta para chatear con RisTA y obtener recomendaciones comerciales personalizadas.",
  "rista_login_btn": "Iniciar sesión",
  "rista_signup_btn": "Registrarse",
  "admin_created": "Creado",
  "admin_credits": "Configuración de créditos",
  "admin_crypto_payments": "Pagos cripto",
  "admin_crypto_trading": "Trading cripto",
  "admin_currency": "Multi-moneda",
  "admin_defi": "Elementos DeFi",
  "admin_delete": "Eliminar",
  "admin_demo": "Acceso demo",
  "admin_demo_banner": "MODO SOLO LECTURA - Cuenta de demostración (Todos los datos están enmascarados)",
  "admin_docs": "Documentación",
  "admin_domain": "Gestor de dominios",
  "admin_edit": "Editar",
  "admin_email_builder": "Constructor de correos",
  "admin_email_templates": "Plantillas de correo",
  "admin_email_templates_desc": "Personalice plantillas de correo con el editor visual de bloques.",
  "admin_escalations": "Escalaciones de chat",
  "admin_fb": "Analítica FB",
  "admin_followups": "Correos de seguimiento",
  "admin_health": "Monitor de salud",
  "admin_health_monitor": "Monitoreo de salud",
  "admin_health_score": "Puntuación de salud",
  "admin_high_leads": "Leads prioritarios",
  "admin_high_value": "Leads de alto valor",
  "admin_image_gen": "Generación de imágenes",
  "admin_integrations": "Integraciones",
  "admin_invoices": "Facturación",
  "admin_kb": "Base de conocimientos",
  "admin_language_requests": "Solicitudes de idiomas",
  "admin_lead_tracking": "Seguimiento de leads",
  "admin_live_analytics": "Analítica en vivo",
  "admin_loading": "Cargando...",
  "admin_logo": "Logo y favicon",
  "admin_milestone_desc": "Descripción (opcional)",
  "admin_milestone_title": "Título del hito",
  "admin_my_account": "Mi cuenta",
  "admin_new": "nuevo",
  "admin_no_data": "No hay datos disponibles",
  "admin_no_matching": "No hay pestañas coincidentes",
  "admin_no_milestones": "Sin hitos aún. ¡Agregue el primero!",
  "admin_notifications": "Notificaciones",
  "admin_out_of": "De",
  "admin_overview": "Resumen",
  "admin_panel": "Panel de administración",
  "admin_payment_opts": "Opciones de pago",
  "admin_pending": "Pendiente",
  "admin_portfolio": "Gestor de portafolio",
  "admin_preloader": "Configuración del precargador",
  "admin_pricing": "Precios dinámicos",
  "admin_promo": "Códigos promocionales",
  "admin_rate_limiting": "Limitación de velocidad",
  "admin_rbac": "Control de acceso",
  "admin_referral_board": "Tabla de referidos",
  "admin_referrals": "Programa de referidos",
  "admin_reports": "Informes admin",
  "admin_requests": "Solicitudes de servicio",
  "admin_reviews": "reseñas",
  "admin_rista": "Servicios RisTA",
  "admin_save": "Guardar",
  "admin_score": "Puntuación",
  "admin_search_tabs": "Buscar pestañas...",
  "admin_sendgrid": "Correo (SendGrid)",
  "admin_service_mgr": "Gestor de servicios",
  "admin_sign_out": "Cerrar sesión",
  "admin_social": "Redes sociales",
  "admin_social_auto": "Automatización social",
  "admin_social_icons": "Iconos sociales",
  "admin_status": "Estado",
  "admin_surveys": "Encuestas de satisfacción",
  "admin_system_admin": "ADMINISTRADOR DEL SISTEMA",
  "admin_system_config": "Configuración del sistema",
  "admin_tester": "Programa de testers",
  "admin_timeline": "Línea de tiempo del proyecto",
  "admin_total": "Total",
  "admin_ui_toggles": "Interruptores UI",
  "admin_unread": "No leído",
  "admin_updated": "Actualizado",
  "admin_users": "Gestión de usuarios",
  "admin_view_all": "Ver todo",
  "billing_manage_desc": "Gestione métodos de pago, vea facturas o actualice datos de facturación a través del portal Stripe.",
  "billing_management": "Gestión de facturación",
  "change_password_btn": "Cambiar contraseña",
  "change_password_confirm": "Confirmar nueva contraseña",
  "change_password_current": "Contraseña actual",
  "change_password_new": "Nueva contraseña",
  "change_password_social": "El cambio de contraseña no está disponible para cuentas de inicio de sesión social.",
  "health_a11y": "Accesibilidad",
  "health_desc": "Análisis completo de SEO, rendimiento, seguridad y accesibilidad de su sitio web.",
  "health_history": "Historial de escaneos",
  "health_login_desc": "Cree una cuenta gratuita para escanear su sitio y seguir mejoras.",
  "health_login_required": "Inicie sesión para usar la puntuación de salud",
  "health_overall": "Puntuación de salud general",
  "health_perf": "Rendimiento",
  "health_premium_badge": "Función Premium",
  "health_response": "Respuesta",
  "health_scan_btn": "Escanear",
  "health_scan_error": "Error al escanear el sitio. Verifique la URL.",
  "health_scanning": "Escaneando...",
  "health_security": "Seguridad",
  "health_seo": "SEO",
  "health_size": "Tamaño",
  "health_title": "Puntuación de salud del sitio web",
  "health_upgrade_btn": "Actualizar a Premium",
  "health_upsell_desc": "Actualice a Premium para escaneos semanales automáticos, alertas por correo y seguimiento de tendencias.",
  "health_upsell_title": "¿Desea monitoreo recurrente?",
  "health_url_ph": "Ingrese URL del sitio (ej: example.com)",
  "nav_currency": "Moneda",
  "nav_health_score": "Puntuación de salud",
  "nav_orders": "Mis pedidos",
  "priority_critical": "Crítica",
  "priority_high": "Alta",
  "priority_low": "Baja",
  "priority_medium": "Media",
  "profile_about": "Sobre usted",
  "profile_appearance": "Apariencia y accesibilidad",
  "profile_change_avatar": "Cambiar avatar",
  "profile_country": "País",
  "profile_country_ph": "ej: España, México, Argentina",
  "profile_interests_hint": "Separe intereses con comas",
  "profile_text_size": "Tamaño del texto",
  "profile_text_size_hint": "Ajuste el tamaño del texto para mejor lectura.",
  "profile_theme": "Tema",
  "seo_cta_desc": "Nuestra auditoría SEO inteligente cubre 100+ puntos de control. Obtenga ayuda profesional.",
  "seo_cta_title": "¿Necesita ayuda con estos problemas?",
  "sp_biz_plan_desc": "Genere un plan de negocios completo con finanzas, análisis de mercado y estrategia de crecimiento.",
  "sp_biz_plan_feat": "Resumen ejecutivo|Análisis de mercado|Proyecciones financieras|Vista competitiva|Estrategia de crecimiento|Formato para inversores",
  "sp_biz_plan_name": "Plan de negocios inteligente",
  "sp_brand_kit_desc": "Paquete completo de identidad de marca con conceptos de logo y assets sociales.",
  "sp_brand_kit_feat": "Conceptos de logo|Paleta de colores|Tipografía|Assets sociales|Directrices de marca|Set de iconos",
  "sp_brand_kit_name": "Logo y kit de marca inteligente",
  "sp_competitor_desc": "Inteligencia competitiva profunda con comparación SEO y análisis de brechas de contenido.",
  "sp_competitor_feat": "Comparación SEO|Revisión diseño|Brechas de contenido|Posicionamiento|Análisis SWOT|Recomendaciones",
  "sp_competitor_name": "Análisis de competencia",
  "sp_email_campaign_desc": "Configuración profesional de campañas de correo con texto, secuencias y segmentación.",
  "sp_email_campaign_feat": "Redacción de correo|Configuración secuencias|Segmentación|Pruebas A/B|Configuración analytics|Diseño plantilla",
  "sp_email_campaign_name": "Configuración de email marketing",
  "sp_free_seo_desc": "Ejecute una auditoría SEO gratuita de cualquier sitio web para descubrir oportunidades.",
  "sp_free_seo_feat": "Resultados instantáneos|100+ verificaciones|Puntuación|Verificación móvil|Escaneo seguridad|Informe gratuito",
  "sp_free_seo_name": "Auditoría SEO gratuita",
  "sp_free_tools_desc": "Acceda a nuestra colección de herramientas gratuitas.",
  "sp_free_tools_feat": "Generador de paletas|Analizador de títulos|Generador de contraseñas|Creador QR|Conversor de unidades|Sin registro",
  "sp_free_tools_name": "Herramientas digitales gratuitas",
  "sp_health_score": "Puntuación de salud del sitio web",
  "sp_health_score_desc": "Análisis completo del sitio cubriendo SEO, rendimiento, seguridad y accesibilidad.",
  "sp_health_score_feat": "Análisis SEO|Verificación rendimiento|Escaneo seguridad|Auditoría accesibilidad|Informe detallado|Consejos de mejora",
  "sp_health_score_name": "Puntuación de salud del sitio web",
  "sp_hosting_desc": "Infraestructura de hosting segura, rápida y confiable para sus sitios y aplicaciones.",
  "sp_hosting_feat": "99.9% uptime|Certificados SSL|Copias diarias|Integración CDN|Monitoreo 24/7|Auto-escalado",
  "sp_hosting_name": "Hosting web gestionado",
  "sp_legal_docs_desc": "Plantillas legales profesionales incluyendo NDA, contratos y términos de servicio.",
  "sp_legal_docs_feat": "Plantillas NDA|Contratos de servicio|Términos de servicio|Políticas de privacidad|Cumplimiento RGPD|Cláusulas personalizadas",
  "sp_legal_docs_name": "Generador de documentos legales",
  "sp_resume_desc": "Cree CVs optimizados para ATS adaptados a su rol objetivo.",
  "sp_resume_feat": "Optimización ATS|Plantillas por industria|Keywords|Carta de presentación|Optimización LinkedIn|Exportar PDF",
  "sp_resume_name": "Creador de CV inteligente",
  "sp_seo_report_desc": "Análisis automatizado del sitio con recomendaciones SEO accionables.",
  "sp_seo_report_feat": "100+ puntos de control|Métricas rendimiento|Recomendaciones SEO|Análisis móvil|Revisión seguridad|Plan de acción",
  "sp_seo_report_name": "Informe de auditoría del sitio",
  "sp_social_cal_desc": "30 días de contenido social generado inteligentemente con estrategia de engagement.",
  "sp_social_cal_feat": "Calendario 30 días|Textos de posts|Estrategia hashtags|Consejos engagement|Mejores horarios|Optimización plataforma",
  "sp_social_cal_name": "Calendario de redes sociales",
  "sp_translation_desc": "Traducción profesional de documentos en 50+ idiomas con adaptación cultural.",
  "sp_translation_feat": "50+ idiomas|Adaptación cultural|Términos técnicos|Entrega rápida|Corrección|Preservación de formato",
  "sp_translation_name": "Traducción inteligente",
  "sp_video_script_desc": "Scripts de video atractivos para YouTube, TikTok y anuncios optimizados para engagement.",
  "sp_video_script_feat": "Scripts YouTube|Contenido TikTok|Textos publicitarios|Optimización gancho|Ubicación CTA|Consejos engagement",
  "sp_video_script_name": "Escritor de scripts de video inteligente",
  "status_blocked": "Bloqueado",
  "status_completed": "Completado",
  "status_in_progress": "En progreso",
  "status_planned": "Planificado",
  "admin_ratings": "Calificaciones y comentarios",
  "analytics_subscription": "Suscripción",
  "developer_title": "API para desarrolladores",
  "developer_subtitle": "Integre nuestros servicios inteligentes en sus aplicaciones",
  "estimate_accept": "Aceptar y enviar",
  "estimate_revise": "Revisar",
  "estimate_title": "Estimación de costos del proyecto",
  "estimate_service": "Servicio",
  "estimate_complexity": "Complejidad",
  "estimate_base_price": "Precio base",
  "estimate_cost": "Costo estimado",
  "estimate_features": "Características principales",
  "hosting_title": "Paquetes de hosting",
  "hosting_subtitle": "Hosting confiable y rápido para su negocio",
  "privacy_s1_title": "1. Información que recopilamos",
  "privacy_s2_title": "2. Cómo usamos su información",
  "privacy_s3_title": "3. Compartición de datos",
  "privacy_s4_title": "4. Seguridad de datos",
  "privacy_s5_title": "5. Sus derechos",
  "privacy_s6_title": "6. Cookies y seguimiento",
  "privacy_s7_title": "7. Retención de datos",
  "privacy_s8_title": "8. Transferencias internacionales",
  "privacy_s9_title": "9. Cambios en esta política",
  "privacy_s10_title": "10. Contáctenos",
  "privacy_intro": "Infinity Business (\"nosotros\"), operado por Liber Nostra d.o.o., está comprometido con la protección de su privacidad.",
  "privacy_last_updated": "Última actualización: 7 de marzo de 2026",
  "terms_s1_title": "1. Introducción",
  "terms_s2_title": "2. Servicios",
  "terms_s3_title": "3. Cuentas de usuario",
  "terms_s4_title": "4. Pagos y facturación",
  "terms_s5_title": "5. Descargo de responsabilidad de servicios inteligentes",
  "terms_s6_title": "6. Propiedad intelectual",
  "terms_s7_title": "7. Privacidad y datos",
  "terms_s8_title": "8. Descargo de responsabilidad de criptomonedas",
  "terms_s9_title": "9. Limitación de responsabilidad",
  "terms_s10_title": "10. Modificaciones",
  "terms_s11_title": "11. Ley aplicable",
  "terms_s12_title": "12. Contacto",
  "terms_last_updated": "Última actualización: febrero 2026",
  "profile_admin_dashboard": "Abrir panel de administración",
  "review_title": "Lo que dicen nuestros clientes",
  "review_subtitle": "Comentarios reales de empresas que hemos ayudado",
  "submit_service_request": "Envíe su solicitud de servicio",
  "walkthrough_gmail": "Asistente inteligente de Gmail",
  "walkthrough_gmail_desc": "Vea cómo RisTA organiza su bandeja de entrada",
  "walkthrough_calendar": "Asesor personal",
  "walkthrough_calendar_desc": "Calendario, tareas y email por chat",
  "walkthrough_ai": "Servicios de sistema inteligente",
  "walkthrough_ai_desc": "Currículum, planes de negocio, kits de marca y más",
  "try_free_title": "Herramientas gratuitas y servicios de prueba",
  "try_free_subtitle": "Sin tarjeta de crédito. Comience a usar nuestras herramientas ahora.",
  "try_free_section": "Completamente gratis — sin cuenta necesaria",
  "try_free_trial_section": "Servicios inteligentes — prueba con créditos",
  "try_free_trial_desc": "Regístrese para obtener créditos y acceder a servicios inteligentes.",
  "try_free_cta": "¿Listo para empezar?",
  "try_free_cta_desc": "Cree una cuenta gratuita para sus primeros créditos y desbloquee todos los servicios.",
  "try_free_cta_btn": "Registrarse gratis",
  "marketplace_close_preview": "Cerrar vista previa",
  "marketplace_live_preview": "Vista previa en vivo",
  "testimonial_1_role": "CEO, TechStart d.o.o.",
  "testimonial_2_role": "Directora de Marketing, BioFresh",
  "testimonial_3_role": "Desarrollador Freelance",
  "referral_subtitle": "Invite amigos y gane recompensas",
  "support_tickets": "Tickets de soporte",
  "admin_support_tickets": "Tickets de soporte",
  "admin_auto_translate": "Traducción automática",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "Prospección IA",
  "admin_project_mgmt": "Gestión de proyectos",
  "admin_analytics_widget": "Widget analítico",
  "admin_doc_mgmt": "Gestión de documentos",
  "admin_webhooks": "Webhooks",
  "admin_white_label": "Marca blanca",
  "admin_multi_tenant": "Multi-inquilino",
  "popular_services": "Servicios populares",
  "popular_services_desc": "Más solicitados por nuestros clientes",
  "purchases": "Compras",
  "admin_funnel": "Embudo de conversión",
  "admin_wl_licensing": "Licencias SaaS",
  "admin_analytics_export": "Exportar analíticas",
  "service_detail_features": "Qué incluye",
  "service_detail_related": "Servicios relacionados",
  "service_detail_back": "Todos los servicios",
  "checkout_currency": "Moneda de pago",
  "upsell_title": "Complete su configuración",
  "upsell_desc": "Clientes que compraron similar también agregaron:",
  "cart_checkout": "Pagar",
  "cart_empty": "Su carrito está vacío",
  "push_notifications": "Notificaciones push",
  "push_enabled": "Notificaciones activadas",
  "push_disabled": "Activar notificaciones",
  "blog_ai_generate": "Generación IA",
  "blog_gen_service": "Generar para servicio",
  "blog_generating": "Generando...",
  "export_revenue": "Informe de ingresos",
  "export_funnel": "Embudo de conversión",
  "export_users": "Lista de usuarios",
  "export_pdf": "Resumen ejecutivo",
  "license_generate": "Generar licencia",
  "license_revoke": "Revocar",
  "license_renew": "Renovar",
  "license_validate": "Validar",
  "tier_starter": "Básico",
  "tier_professional": "Profesional",
  "tier_enterprise": "Empresa",
  "blog_subtitle": "Perspectivas, actualizaciones y guías de Infinity Business.",
  "blog_search_placeholder": "Buscar artículos...",
  "blog_all": "Todos",
  "blog_no_posts": "No se encontraron publicaciones. ¡Vuelve pronto!",
  "blog_prev": "Anterior",
  "blog_next": "Siguiente",
  "blog_back": "Volver al blog",
  "micro_tools": "Micro herramientas inteligentes",
  "micro_tools_title": "Micro herramientas inteligentes",
  "micro_tools_subtitle": "Micro herramientas gratuitas impulsadas por IA",
  "color_palette_title": "Generador de paleta de colores",
  "color_palette_desc": "Genera paletas de colores para tu marca",
  "color_palette_generate": "Generar paleta",
  "color_palette_copy": "Copiar",
  "color_palette_copied": "¡Copiado!",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "Complementario",
  "color_palette_analogous": "Análogo",
  "color_palette_triadic": "Triádico",
  "color_palette_monochromatic": "Monocromático",
  "admin_menu_overview": "Resumen",
  "admin_menu_users": "Usuarios",
  "admin_menu_blog": "Gestor de blog",
  "admin_menu_analytics": "Analítica",
  "admin_menu_settings": "Configuración",
  "admin_menu_services": "Servicios",
  "admin_menu_chat": "Sesiones de chat",
  "admin_menu_notifications": "Notificaciones",
  "admin_menu_support": "Soporte",
  "admin_menu_security": "Seguridad",
  "admin_menu_backup": "Copia de seguridad",
  "admin_menu_revenue": "Ingresos",
  "admin_menu_funnel": "Embudo",
  "admin_menu_invoicing": "Facturación",
  "admin_menu_projects": "Proyectos",
  "admin_menu_email": "Editor de correo",
  "admin_menu_ai_config": "Config. IA",
  "admin_menu_live_analytics": "Analítica en vivo",
  "admin_menu_platform_audit": "Auditoría de plataforma",
  "docs_title": "Documentación",
  "docs_subtitle": "Aprende a usar nuestra plataforma",
  "try_free_title": "Probar gratis",
  "try_free_subtitle": "Experimenta nuestros servicios sin costo",
  "subscription_title": "Planes de suscripción",
  "subscription_subtitle": "Elige el plan que se ajuste a ti",
  "portfolio_title": "Portafolio",
  "portfolio_subtitle": "Nuestro trabajo habla por sí mismo",
  "svc_web-dev_label": "Desarrollo Web",
  "svc_web-dev_desc": "Sitios web, páginas de destino y aplicaciones web",
  "svc_mobile-app_label": "Desarrollo de Apps Móviles",
  "svc_mobile-app_desc": "Apps iOS & Android, soluciones multiplataforma",
  "svc_graphic-design_label": "Diseño Gráfico",
  "svc_graphic-design_desc": "Logos, branding, materiales de marketing",
  "svc_custom-software_label": "Software a Medida",
  "svc_custom-software_desc": "Automatización empresarial personalizada",
  "svc_ai-business-plan_label": "Generador de Plan de Negocios",
  "svc_ai-business-plan_desc": "Plan completo con finanzas y análisis de mercado",
  "svc_ai-seo-report_label": "Auditoría Web y Reporte SEO",
  "svc_ai-seo-report_desc": "Análisis automatizado con recomendaciones",
  "svc_ai-email-campaign_label": "Configuración de Email Marketing",
  "svc_ai-email-campaign_desc": "IA escribe textos y configura secuencias de email",
  "svc_ai-competitor-analysis_label": "Informe de Análisis Competitivo",
  "svc_ai-competitor-analysis_desc": "Inteligencia de mercado y posicionamiento",
  "svc_ai-legal-docs_label": "Generador de Documentos Legales",
  "svc_ai-legal-docs_desc": "NDA, contratos, plantillas de términos de servicio",
  "svc_crypto-education_label": "Educación Cripto",
  "svc_crypto-education_desc": "Aprende blockchain, DeFi y fundamentos cripto",
  "svc_investment-tools_label": "Herramientas de Inversión",
  "svc_investment-tools_desc": "Seguimiento de portafolio y análisis de mercado",
  "svc_defi-solutions_label": "Soluciones DeFi",
  "svc_defi-solutions_desc": "Contratos inteligentes, yield farming",
  "svc_personal-advertising_label": "Marca Personal",
  "svc_personal-advertising_desc": "Construye tu presencia online",
  "svc_ai-resume_label": "Constructor de CV Inteligente",
  "svc_ai-resume_desc": "CVs optimizados para ATS",
  "svc_ai-brand-kit_label": "Logo y Kit de Marca Inteligente",
  "svc_ai-brand-kit_desc": "Logo, paleta de colores, tipografía y assets sociales",
  "svc_ai-social-calendar_label": "Calendario de Redes Sociales",
  "svc_ai-social-calendar_desc": "30 días de posts generados por IA",
  "svc_ai-translation_label": "Servicio de Traducción Inteligente",
  "svc_ai-translation_desc": "Traducción profesional en 50+ idiomas",
  "svc_ai-video-script_label": "Escritor de Guiones de Video",
  "svc_ai-video-script_desc": "Guiones para YouTube, TikTok y anuncios",
  "admin_grp_dashboard": "Panel",
  "admin_grp_users": "Usuarios y acceso",
  "admin_grp_analytics": "Análisis e informes",
  "admin_grp_services": "Servicios y precios",
  "admin_grp_crypto": "Cripto y DeFi",
  "admin_grp_leads": "Clientes potenciales",
  "admin_grp_content": "Contenido",
  "admin_grp_comm": "Comunicación",
  "admin_grp_social": "Redes sociales",
  "admin_grp_ai": "IA y automatización",
  "admin_grp_design": "Diseño y marca",
  "admin_grp_system": "Sistema",
  "admin_grp_projects": "Proyectos y QA",
  "color_palette_professional": "Profesional",
  "color_palette_playful": "Divertido",
  "color_palette_luxury": "Lujo",
  "color_palette_nature": "Naturaleza",
  "color_palette_tech": "Tecnología",
  "color_palette_warm": "Cálido",
  "color_palette_cool": "Frío",
  "blog_translating": "Traduciendo artículo...",
  "blog_translated_cached": "Traducido",
  "blog_translated_fresh": "Recién traducido",
  "blog_show_original": "Mostrar original",
  "privacy_s1_content": "Recopilamos información que usted nos proporciona directamente, incluyendo:\n- **Información de cuenta**: Nombre, correo electrónico y contraseña.\n- **Solicitudes de servicio**: Detalles del proyecto, presupuesto y datos de contacto.\n- **Información de pago**: Datos de facturación procesados por nuestros socios (Stripe, myPOS).\n- **Datos de comunicación**: Mensajes a través de RisTA, formularios de contacto y correo electrónico.\n- **Datos de uso**: Tipo de navegador, dirección IP, páginas visitadas.",
  "privacy_s2_content": "Utilizamos la información recopilada para:\n- Proporcionar, mantener y mejorar nuestros servicios\n- Procesar transacciones y enviar información relacionada\n- Enviar avisos técnicos, actualizaciones y mensajes de soporte\n- Responder a sus comentarios, preguntas y solicitudes\n- Monitorear y analizar tendencias y actividades\n- Detectar y prevenir actividades fraudulentas\n- Personalizar su experiencia con RisTA",
  "privacy_s3_content": "No vendemos su información personal. Podemos compartir información con:\n- **Proveedores de servicios**: Empresas que realizan servicios en nuestro nombre.\n- **Requisitos legales**: Cuando lo exija la ley.\n- **Transferencias comerciales**: En relación con fusiones o ventas.\n- **Consentimiento**: Con su consentimiento explícito.",
  "privacy_s4_content": "Implementamos medidas de seguridad estándar:\n- Cifrado de datos en tránsito (TLS/SSL) y en reposo\n- Soporte de autenticación de dos factores (2FA)\n- Auditorías de seguridad regulares\n- Controles de acceso y autenticación\n- Procesamiento seguro de pagos",
  "privacy_s5_content": "Bajo las leyes de protección de datos aplicables (incluido GDPR), usted tiene derecho a:\n- **Acceso**: Solicitar una copia de sus datos personales\n- **Rectificación**: Solicitar corrección de datos inexactos\n- **Eliminación**: Solicitar eliminación de sus datos\n- **Restricción**: Solicitar restricción del procesamiento\n- **Portabilidad**: Solicitar transferencia en formato legible por máquina\n- **Objeción**: Oponerse al procesamiento\n- **Retirar consentimiento**: Retirar el consentimiento en cualquier momento\n\nContáctenos en privacy@infinitybusiness.org.",
  "privacy_s6_content": "Utilizamos cookies esenciales para su sesión y preferencias. Puede controlar las cookies desde su navegador.",
  "privacy_s7_content": "Conservamos sus datos solo el tiempo necesario para cumplir con los fines para los que fueron recopilados.",
  "privacy_s8_content": "Sus datos pueden ser transferidos fuera del EEE. Garantizamos las salvaguardias apropiadas.",
  "privacy_s9_content": "Podemos actualizar esta política de privacidad ocasionalmente. Los cambios materiales se publicarán en esta página.",
  "privacy_s10_content": "Para preguntas, contacte:\n\n**Liber Nostra d.o.o.**\nEmail: privacy@infinitybusiness.org\nWeb: infinitybusiness.org",
  "terms_s1_content": "Bienvenido a Infinity Business (\"infinitybusiness.org\"), operado por **Liber Nostra d.o.o.**. Al acceder a nuestra plataforma, acepta estos Términos y Condiciones.",
  "terms_s2_content": "Infinity Business ofrece servicios digitales con IA:\n- Desarrollo web, apps móviles y diseño gráfico (B2B)\n- Servicios empresariales y publicidad digital\n- Educación cripto, herramientas de inversión y DeFi (P2P)\n- Asistente IA RisTA\n- Dominios y hosting web",
  "terms_s3_content": "Para ciertas funciones debe crear una cuenta. Es responsable de la confidencialidad de sus credenciales.",
  "terms_s4_content": "Los servicios pueden requerir pago. Pagos procesados por terceros (Stripe, PayPal, criptomonedas). Políticas de reembolso:\n- **Servicios únicos**: No reembolsables.\n- **Suscripciones**: Cancelables en cualquier momento.\n- **Proyectos personalizados**: Según acuerdo individual.",
  "terms_s5_content": "Nuestro asistente IA \"RisTA\" proporciona orientación automatizada. Solo con fines informativos.",
  "terms_s6_content": "Todo el contenido de esta plataforma es propiedad de Liber Nostra d.o.o.",
  "terms_s7_content": "Su uso de la plataforma también está regido por nuestra Política de Privacidad.",
  "terms_s8_content": "Los servicios relacionados con criptomonedas son solo informativos. No brindamos asesoramiento financiero.",
  "terms_s9_content": "Liber Nostra d.o.o. no será responsable por daños indirectos o consecuentes.",
  "terms_s10_content": "Nos reservamos el derecho de modificar estos Términos en cualquier momento.",
  "terms_s11_content": "Estos Términos se rigen por las leyes de la República de Eslovenia.",
  "terms_s12_content": "Para preguntas, contáctenos o escriba a support@infinitybusiness.org.",
  "admin_ad_generator": "Generador de anuncios",
  "admin_add": "Agregar",
  "admin_add_prompt": "Agregar prompt",
  "admin_admin": "Administrador",
  "admin_advanced_reporting": "Informes avanzados",
  "admin_all": "Todos",
  "admin_analytics_dashboard": "Panel de analisis",
  "admin_api_key": "Clave API",
  "admin_apply": "Aplicar",
  "admin_approved": "Aprobado",
  "admin_archive": "Archivar",
  "admin_are_you_sure": "Esta seguro?",
  "admin_audit_alerts": "Alertas de auditoria",
  "admin_author": "Autor",
  "admin_avg_session": "Sesion promedio",
  "admin_back": "Atras",
  "admin_badge": "Insignia",
  "admin_balance": "Saldo",
  "admin_banned": "Bloqueado",
  "admin_blog_manager": "Gestor de blog",
  "admin_body": "Cuerpo",
  "admin_bounce_rate": "Tasa de rebote",
  "admin_browser": "Navegador",
  "admin_campaign": "Campana",
  "admin_cannot_undo": "Esta accion no se puede deshacer",
  "admin_category": "Categoria",
  "admin_click_rate": "Tasa de clics",
  "admin_close": "Cerrar",
  "admin_completed": "Completado",
  "admin_configuration": "Configuracion",
  "admin_confirm": "Confirmar",
  "admin_contact_info": "Informacion de contacto",
  "admin_content": "Contenido",
  "admin_conversations": "Conversaciones",
  "admin_conversion_funnel": "Embudo de conversion",
  "admin_conversion_rate": "Tasa de conversion",
  "admin_copied": "Copiado al portapapeles",
  "admin_copy": "Copiar",
  "admin_count": "Cantidad",
  "admin_country": "Pais",
  "admin_create": "Crear",
  "admin_create_experiment": "Crear experimento",
  "admin_create_new": "Crear nuevo",
  "admin_created_success": "Creado exitosamente",
  "admin_credit_config": "Configuracion de creditos",
  "admin_critical": "Critico",
  "admin_custom": "Personalizado",
  "admin_daily": "Diario",
  "admin_date": "Fecha",
  "admin_delete_failed": "Error al eliminar",
  "admin_deleted_success": "Eliminado exitosamente",
  "admin_demo_access": "Acceso demo",
  "admin_description": "Descripcion",
  "admin_deselect_all": "Deseleccionar todo",
  "admin_details": "Detalles",
  "admin_device": "Dispositivo",
  "admin_disable": "Desactivar",
  "admin_disabled": "Desactivado",
  "admin_doc_viewer": "Visor de documentos",
  "admin_documentation": "Documentacion",
  "admin_download": "Descargar",
  "admin_draft": "Borrador",
  "admin_duplicate": "Duplicar",
  "admin_email": "Correo",
  "admin_enable": "Activar",
  "admin_enabled": "Activado",
  "admin_end_date": "Fecha de fin",
  "admin_endpoint": "Punto final",
  "admin_error": "Error",
  "admin_escalation_queue": "Cola de escalacion",
  "admin_event": "Evento",
  "admin_events": "Eventos",
  "admin_experiment_name": "Nombre del experimento",
  "admin_export": "Exportar",
  "admin_facebook_analytics": "Analisis de Facebook",
  "admin_false": "Falso",
  "admin_filter": "Filtrar",
  "admin_frequency": "Frecuencia",
  "admin_generate": "Generar",
  "admin_headers": "Encabezados",
  "admin_health_monitoring": "Monitoreo de salud",
  "admin_high": "Alto",
  "admin_high_value_leads": "Leads de alto valor",
  "admin_id": "ID",
  "admin_image": "Imagen",
  "admin_import": "Importar",
  "admin_in_progress": "En progreso",
  "admin_inactive": "Inactivo",
  "admin_inbox": "Bandeja de entrada",
  "admin_speed_audit": "Auditoría de Velocidad",
  "admin_info": "Info",
  "admin_ip_address": "Direccion IP",
  "admin_joined": "Se unio",
  "admin_knowledge_base": "Base de conocimiento",
  "admin_language": "Idioma",
  "admin_last_activity": "Ultima actividad",
  "admin_last_login": "Ultimo acceso",
  "admin_last_triggered": "Ultimo activacion",
  "admin_lead_score": "Puntuacion del lead",
  "admin_level": "Nivel",
  "admin_load_failed": "Error al cargar",
  "admin_loading_data": "Cargando datos...",
  "admin_low": "Bajo",
  "admin_medium": "Medio",
  "admin_messages": "Mensajes",
  "admin_method": "Metodo",
  "admin_monetization": "Monetizacion",
  "admin_monthly": "Mensual",
  "admin_name": "Nombre",
  "admin_next": "Siguiente",
  "admin_no": "No",
  "admin_no_data_available": "Sin datos disponibles",
  "admin_no_experiments": "No hay experimentos",
  "admin_no_leads": "No hay leads",
  "admin_no_prompts": "No hay prompts",
  "admin_no_results": "Sin resultados",
  "admin_no_results_found": "No se encontraron resultados",
  "admin_none": "Ninguno",
  "admin_off": "Apagado",
  "admin_on": "Encendido",
  "admin_open_rate": "Tasa de apertura",
  "admin_page_views": "Vistas de pagina",
  "admin_partner_badges": "Insignias de socios",
  "admin_payload": "Carga util",
  "admin_payment_options": "Opciones de pago",
  "admin_platform": "Plataforma",
  "admin_platform_audit": "Auditoria de plataforma",
  "admin_points": "Puntos",
  "admin_portfolio_manager": "Gestor de portafolio",
  "admin_preloader_config": "Config. de precarga",
  "admin_preview": "Vista previa",
  "admin_previous": "Anterior",
  "admin_price": "Precio",
  "admin_priority": "Prioridad",
  "admin_prompt_name": "Nombre del prompt",
  "admin_prompt_text": "Texto del prompt",
  "admin_published": "Publicado",
  "admin_recipients": "Destinatarios",
  "admin_referral": "Referencia",
  "admin_referral_leaderboard": "Tabla de referidos",
  "admin_refresh": "Actualizar",
  "admin_rejected": "Rechazado",
  "admin_remove": "Eliminar",
  "admin_reset": "Restablecer",
  "admin_response_time": "Tiempo de respuesta",
  "admin_restore": "Restaurar",
  "admin_results": "Resultados",
  "admin_retry": "Reintentar",
  "admin_revenue_dashboard": "Panel de ingresos",
  "admin_rista_services": "Servicios RisTA",
  "admin_role": "Rol",
  "admin_save_changes": "Guardar cambios",
  "admin_save_failed": "Error al guardar",
  "admin_saved_success": "Guardado exitosamente",
  "admin_scheduled": "Programado",
  "admin_search": "Buscar",
  "admin_select": "Seleccionar",
  "admin_select_all": "Seleccionar todo",
  "admin_send": "Enviar",
  "admin_sent_success": "Enviado exitosamente",
  "admin_server_resources": "Recursos del servidor",
  "admin_service_manager": "Gestor de servicios",
  "admin_session_duration": "Duracion de sesion",
  "admin_settings": "Configuracion",
  "admin_slug": "Slug",
  "admin_social_automation": "Automatizacion social",
  "admin_something_wrong": "Algo salio mal",
  "admin_source": "Fuente",
  "admin_start_date": "Fecha de inicio",
  "admin_subject": "Asunto",
  "admin_submit": "Enviar",
  "admin_subscribers": "Suscriptores",
  "admin_success": "Exito",
  "admin_suspended": "Suspendido",
  "admin_system_prompt": "Prompt del sistema",
  "admin_tags": "Etiquetas",
  "admin_template": "Plantilla",
  "admin_templates": "Plantillas",
  "admin_test_results": "Resultados de pruebas",
  "admin_tester_program": "Programa de testers",
  "admin_title": "Titulo",
  "admin_total_revenue": "Ingresos totales",
  "admin_total_sessions": "Sesiones totales",
  "admin_total_users": "Usuarios totales",
  "admin_trigger": "Disparador",
  "admin_true": "Verdadero",
  "admin_try_again": "Por favor intente de nuevo",
  "admin_type": "Tipo",
  "admin_unique_visitors": "Visitantes unicos",
  "admin_unsubscribed": "Dado de baja",
  "admin_unverified": "No verificado",
  "admin_update": "Actualizar",
  "admin_updated_success": "Actualizado exitosamente",
  "admin_upload": "Subir",
  "admin_urgent": "Urgente",
  "admin_user": "Usuario",
  "admin_variant_a": "Variante A",
  "admin_variant_b": "Variante B",
  "admin_verified": "Verificado",
  "admin_version": "Version",
  "admin_view": "Ver",
  "admin_view_details": "Ver detalles",
  "admin_viewer": "Visor",
  "admin_warning": "Advertencia",
  "admin_webhook_url": "URL del Webhook",
  "admin_weekly": "Semanal",
  "admin_yes": "Si",
  "admin_analytics_digestadmin_analytics_digest": "Resumen de analisis",
  "admin_blog_health": "Salud del blog",
  "credit_title": "Créditos",
  "credit_subtitle": "Saldo prepago para servicios inteligentes",
  "credit_available_balance": "Saldo disponible",
  "credit_tab_balance": "Saldo",
  "credit_tab_topup": "Recargar",
  "credit_tab_history": "Historial",
  "credit_tab_services": "Servicios",
  "credit_tab_crypto": "Cripto",
  "credit_balance_desc": "Su crédito se puede usar para cualquier servicio inteligente:",
  "credit_bulk_discounts": "Descuentos por volumen",
  "credit_add_credits": "Agregar créditos",
  "credit_select_amount": "Seleccione un monto o ingrese un valor personalizado:",
  "credit_bonus": "bono",
  "credit_bonus_detail": "Obtendrá",
  "credit_total_word": "total",
  "credit_method_card": "Tarjeta",
  "credit_method_crypto": "Cripto",
  "credit_processing": "Procesando...",
  "credit_add_btn": "Agregar",
  "credit_no_txn": "Sin transacciones aún",
  "credit_txn_topup": "Recarga",
  "credit_txn_promo": "Crédito promo",
  "credit_txn_auto": "Compra automática",
  "credit_txn_purchase": "Compra",
  "credit_svc_intelligent": "Servicio inteligente",
  "credit_svc_available": "Disponible",
  "credit_svc_need_more": "Necesita",
  "credit_svc_more": "más",
  "credit_crypto_send": "Enviar",
  "credit_crypto_amount": "Monto:",
  "credit_crypto_equivalent": "equivalente",
  "credit_crypto_network": "Red:",
  "credit_crypto_wallet": "Dirección de billetera",
  "credit_crypto_confirm": "Los créditos se agregarán una vez confirmada la transacción.",
  "credit_payment_id": "ID de pago:",
  "credit_crypto_back": "Volver a selección cripto",
  "credit_crypto_select_title": "Seleccionar criptomoneda para recarga",
  "credit_crypto_choose_desc": "Elija una moneda. Recibirá una dirección de billetera para el pago.",
  "credit_crypto_select_btn": "Seleccionar",
  "credit_minimum": "Mínimo €5",
  "credit_redirecting": "Redirigiendo...",
  "credit_topup_failed": "Error en recarga",
  "credit_crypto_failed": "Error al iniciar pago cripto",
  "cart_title": "Carrito",
  "cart_total": "Total",
  "cart_stripe_checkout": "Pago con Stripe",
  "cart_credits": "Créditos",
  "cart_secure_stripe": "Pago seguro con Stripe",
  "cart_insufficient": "Créditos insuficientes. Recargue primero o elija pago con tarjeta.",
  "cart_pay_card": "Pagar con tarjeta",
  "cart_pay_credits_btn": "Pagar con créditos",
  "cart_clear": "Vaciar carrito",
  "cart_processing": "Procesando...",
  "cart_payment_success": "¡Pago exitoso! Su pedido está siendo procesado.",
  "cart_complete_setup": "Complete su configuración",
  "cart_also_added": "Clientes con compras similares también agregaron:",
  "cart_add": "Agregar",
  "cart_standard": "Estándar",
  "cart_remaining_balance": "Saldo restante:",
  "cart_checkout_failed": "Error en el pago",
  "cart_checkout_no_session": "No se pudo crear la sesión de pago",
  "cart_purchased": "Comprado",
  "cart_services_with_credits": "servicio(s) con créditos!",
  "credits_balance_title": "Saldo de créditos",
  "credits_topup_btn": "Recargar créditos",
  "credits_rate": "1 EUR = 1 Crédito",
  "credits_total_topup": "Total recargado",
  "credits_spent_credits": "Gastado (Créditos)",
  "credits_spent_payments": "Gastado (Pagos)",
  "credits_txn_history": "Historial de transacciones",
  "credits_no_txn": "Sin transacciones",
  "credits_txn_topup": "Recarga",
  "credits_txn_promo": "Crédito promo",
  "credits_txn_purchase": "Compra de servicio",
  "credits_txn_ai": "Servicio IA",
  "credits_order_history": "Historial de pedidos",
  "credits_order_label": "Pedido:",
  "chat_translate_btn": "Traducir al inglés",
  "chat_translating": "Traduciendo...",
  "chat_translated_label": "Mostrando traducción al inglés. Haga clic en \"Mostrar original\" para ver los mensajes originales.",
  "chat_show_original": "Mostrar original",
  "chat_show_translated": "Mostrar traducción",
  "pkg_section_badge": "Ofertas por tiempo limitado",
  "pkg_section_title": "Lanza tu negocio",
  "pkg_section_title_highlight": "Hoy",
  "pkg_section_subtitle": "Paquetes premium diseñados para que estés en línea rápidamente, con tecnología inteligente incorporada desde el primer día.",
  "pkg_section_footer": "Todos los precios excluyen el IVA donde corresponda. ¿No estás seguro de qué paquete encaja? Habla con RisTA para una consulta gratuita.",
  "pkg_cta_default": "Comenzar",
  "admin_package_mgr": "Administrador de Paquetes",
  "admin_pkg_title": "Paquetes de Página de Aterrizaje",
  "admin_pkg_subtitle": "Gestionar paquetes de precios destacados mostrados en la página de aterrizaje",
  "admin_pkg_seed": "Valores Predeterminados",
  "admin_pkg_new": "Nuevo Paquete",
  "admin_pkg_create_title": "Crear Nuevo Paquete",
  "admin_pkg_edit_title": "Editar Paquete",
  "admin_pkg_name": "Nombre del Paquete",
  "admin_pkg_tagline": "Eslogan",
  "admin_pkg_description": "Descripción",
  "admin_pkg_price": "Precio",
  "admin_pkg_currency": "Moneda",
  "admin_pkg_price_note": "Nota de Precio",
  "admin_pkg_badge": "Distintivo",
  "admin_pkg_accent": "Color de Acento",
  "admin_pkg_cta_text": "Texto del Botón CTA",
  "admin_pkg_cta_link": "Enlace CTA (opcional)",
  "admin_pkg_sort": "Ordenar",
  "admin_pkg_features": "Características / Servicios Incluidos",
  "admin_pkg_add_feature": "Añadir Característica",
  "admin_pkg_highlighted": "Destacado",
  "admin_pkg_normal": "Normal",
  "admin_pkg_create": "Crear Paquete",
  "admin_pkg_save": "Guardar Cambios",
  "admin_pkg_saving": "Guardando...",
  "admin_pkg_cancel": "Cancelar",
  "admin_pkg_empty_title": "No hay paquetes configurados aún",
  "admin_pkg_empty_desc": "Haz clic en Valores Predeterminados para generar dos paquetes iniciales o crea el tuyo propio.",
  "admin_pkg_features_label": "características",
  "admin_pkg_sort_label": "Ordenar",
  "admin_pkg_delete_confirm": "¿Eliminar este paquete? Será eliminado de la página de aterrizaje.",
  "admin_pkg_feature_placeholder": "Descripción de la característica...",
  "admin_pkg_pricenote_placeholder": "p. ej. Un solo pago / +5% de participación en ingresos",
  "admin_pkg_badge_placeholder": "p. ej. MEJOR VALOR",
  "admin_pkg_loading": "Cargando paquetes...",
  "pkg_qa_have_domain": "S00ed, tengo un dominio",
  "pkg_qa_need_domain": "Necesito un dominio",
  "pkg_qa_describe_biz": "Permítame describir mi negocio",
  "pkg_qa_more_info": "Cuéntame más sobre este paquete",
  "sp_managed_hosting": "Hosting Gestionado",
  "sp_managed_hosting_desc": "Hosting totalmente gestionado con monitoreo y soporte.",
  "sp_enterprise_ad": "Publicidad Empresarial",
  "sp_enterprise_ad_desc": "Campañas publicitarias a gran escala con estrategia dedicada.",
  "sp_email_marketing": "Configuración de Email Marketing",
  "sp_email_marketing_desc": "Secuencias de email profesionales y automatización.",
  "sp_competitor_analysis": "Informe de Análisis Competitivo",
  "sp_competitor_analysis_desc": "Inteligencia de mercado y posicionamiento competitivo.",
  "sp_website_audit": "Auditoría Web e Informe SEO",
  "sp_website_audit_desc": "Análisis completo del sitio con recomendaciones accionables.",
  "sp_managed_trading": "Trading Gestionado",
  "sp_managed_trading_desc": "Trading gestionado por expertos con estrategias probadas.",
  "sp_trading_consult": "Consultoría de Trading",
  "sp_trading_consult_desc": "Sesiones individuales de estrategia de trading.",
  "sp_domains": "LiveDomain Aftermarket",
  "sp_domains_desc": "Adquisición premium de dominios y ofertas aftermarket.",
  "sp_domain_mgmt": "Gestión de Dominios",
  "sp_domain_mgmt_desc": "Gestión DNS, renovaciones y transferencias.",
  "sp_defi": "Soluciones DeFi",
  "sp_defi_desc": "Contratos inteligentes, yield farming y pools de liquidez.",
  "sp_personal_brand": "Marca Personal",
  "sp_personal_brand_desc": "Construye tu presencia online y marca personal.",
  "sp_ad_gen": "Generador de Anuncios",
  "sp_ad_gen_desc": "Genera textos publicitarios de alta conversión al instante.",
  "sp_priority": "Cola Prioritaria",
  "sp_priority_desc": "Respuesta garantizada en 4 horas.",
  "sp_maintenance": "Plan de Mantenimiento",
  "sp_maintenance_desc": "Mantenimiento continuo, actualizaciones y soporte técnico.",
  "sp_consulting": "Consultoría Inteligente",
  "sp_consulting_desc": "Consultoría individual con nuestros expertos en tecnología.",
  "sp_market_snapshot": "Panorama del Mercado",
  "sp_market_snapshot_desc": "Vista rápida del panorama del mercado y tendencias.",
  "sp_trend_explainer": "Explicador de Tendencias",
  "sp_trend_explainer_desc": "Comprende tendencias emergentes en tu industria.",
  "sp_competitor_qa": "Preguntas sobre Competidores",
  "sp_competitor_qa_desc": "Respuestas sobre las estrategias de tus competidores.",
  "sp_country_entry": "Verificación de Entrada al País",
  "sp_country_entry_desc": "Evalúa la preparación del mercado para expansión internacional.",
  "sp_vendor_shortlist": "Lista de Proveedores",
  "sp_vendor_shortlist_desc": "Lista curada de proveedores para tus necesidades.",
  "sp_tam_logic": "Boceto TAM",
  "sp_tam_logic_desc": "Estimación del mercado total con desglose lógico.",
  "sp_positioning": "Ángulo de Posicionamiento",
  "sp_positioning_desc": "Análisis de estrategia de posicionamiento producto + audiencia.",
  "sp_addon_title": "Complementos y Soporte",
  "sp_addon_desc": "Potencia tu proyecto con soporte prioritario y consultoría experta.",
  "sp_research_title": "Productos de Investigación Inteligente",
  "sp_research_desc": "Inteligencia de mercado bajo demanda y herramientas de análisis.",
  "tier_section_badge": "Paquetes Inteligentes",
  "tier_section_title": "Elige Tu",
  "tier_section_highlight": "Plan de Crecimiento",
  "tier_section_subtitle": "Paquetes diseñados para entregar máximo valor. Elige el nivel adecuado para ti.",
  "tier_one_time": "Pago Único",
  "tier_monthly": "Mensual",
  "tier_section_footer": "Todos los precios excluyen IVA. ¿Necesitas un paquete personalizado? Habla con RisTA.",
  "tier_name_starter": "Starter",
  "tier_name_growth": "Growth",
  "tier_name_pro": "Pro",
  "tier_name_enterprise": "Enterprise",
  "tier_tag_starter": "Perfecto para comenzar tu presencia digital",
  "tier_tag_growth": "Escala tu negocio con herramientas inteligentes y marketing",
  "tier_tag_pro": "Crecimiento digital completo para negocios serios",
  "tier_tag_enterprise": "Transformación digital completa para tu empresa",
  "tier_cta_starter": "Obtener Starter",
  "tier_cta_growth": "Obtener Growth",
  "tier_cta_pro": "Obtener Pro",
  "tier_cta_enterprise": "Obtener Enterprise",
  "tier_badge_popular": "POPULAR",
  "tier_badge_best": "MEJOR VALOR",
  "tier_badge_all": "TODO EN UNO",
  "tier_per_mo": "mes",
  "tier_once_label": "pago único",
  "tier_or_monthly": "o",
  "tier_f_starter_1": "Generador inteligente de plan de negocio",
  "tier_f_starter_2": "Constructor inteligente de CV (3 unid.)",
  "tier_f_starter_3": "Auditoría web e informe SEO",
  "tier_f_starter_4": "Logo y kit de marca inteligente",
  "tier_f_starter_5": "Informe panorámico del mercado",
  "tier_f_starter_6": "Borrador de respuestas FAQ",
  "tier_f_starter_7": "Esquema de blog desde tendencia",
  "tier_f_starter_8": "Soporte email en 48h",
  "tier_f_growth_1": "Todo del Starter",
  "tier_f_growth_2": "Campaña de email inteligente",
  "tier_f_growth_3": "Calendario y análisis redes sociales (3 meses)",
  "tier_f_growth_4": "Informe análisis competitivo",
  "tier_f_growth_5": "Generador de anuncios (5 campañas)",
  "tier_f_growth_6": "Generador de emails de alcance",
  "tier_f_growth_7": "Explicador de tendencias",
  "tier_f_growth_8": "Análisis de posicionamiento",
  "tier_f_growth_9": "Soporte email prioritario en 24h",
  "tier_f_pro_1": "Todo del Growth",
  "tier_f_pro_2": "Setup SEO y marketing digital",
  "tier_f_pro_3": "Setup de email marketing",
  "tier_f_pro_4": "Escritor inteligente de guiones (5 unid.)",
  "tier_f_pro_5": "Boceto rápido de lógica TAM",
  "tier_f_pro_6": "Lista de verificación de riesgos",
  "tier_f_pro_7": "Priorización de funcionalidades",
  "tier_f_pro_8": "Borrador lista de proveedores",
  "tier_f_pro_9": "Sesión de consultoría inteligente (2h)",
  "tier_f_pro_10": "Soporte prioritario en 12h",
  "tier_f_ent_1": "Todo del Pro",
  "tier_f_ent_2": "Desarrollo de software a medida",
  "tier_f_ent_3": "Estrategia publicitaria empresarial",
  "tier_f_ent_4": "Hosting gestionado (12 meses)",
  "tier_f_ent_5": "Plan de mantenimiento (6 meses)",
  "tier_f_ent_6": "Consultoría inteligente (10h)",
  "tier_f_ent_7": "Verificación entrada al país",
  "tier_f_ent_8": "Resumen ejecutivo para presentaciones",
  "tier_f_ent_9": "Declaración de problema JTBD",
  "tier_f_ent_10": "Gestor de cuenta dedicado",
  "tier_f_ent_11": "Cola prioritaria (respuesta 4h)",
  "calc_title": "Calculadora de Precios",
  "calc_subtitle": "Compara servicios individuales con paquetes para ver tus ahorros.",
  "calc_badge": "Ahorra Más",
  "calc_select_services": "Selecciona Servicios",
  "calc_search_placeholder": "Buscar servicios...",
  "calc_selected": "seleccionados",
  "calc_your_selection": "Tu Selección",
  "calc_individual_total": "Total Individual",
  "calc_best_tier": "Mejor Paquete",
  "calc_you_save": "Ahorras",
  "calc_no_services": "Selecciona servicios para ver ahorros",
  "calc_clear_all": "Limpiar todo",
  "calc_get_tier": "Obtener Este Paquete",
  "calc_individual_cheaper": "Los servicios individuales ya son rentables. ¡Añade más para desbloquear ahorros!",
  "referred_by": "Referido por",
  "referral_signup_reward": "Registrate para conectar tu cuenta con esta referencia.",
  "badge_coming_soon": "Próximamente",
  "badge_available_soon": "Disponible pronto",
  "badge_from_price": "desde",
  "badge_preparing": "Estamos preparando este servicio para ti",
  "svc_managed-hosting_label": "Hosting gestionado",
  "svc_managed-hosting_desc": "Hosting completamente gestionado con monitoreo y soporte",
  "svc_enterprise-advertising_label": "Publicidad empresarial",
  "svc_enterprise-advertising_desc": "Campañas publicitarias a gran escala con estrategia dedicada",
  "svc_email-marketing_label": "Configuración de email marketing",
  "svc_email-marketing_desc": "Secuencias de correo electrónico, plantillas y automatización",
  "svc_competitor-analysis_label": "Informe de análisis competitivo",
  "svc_competitor-analysis_desc": "Inteligencia de mercado y posicionamiento competitivo",
  "svc_legal-docs_label": "Generador de documentos legales",
  "svc_legal-docs_desc": "NDA, contratos, plantillas de términos de servicio",
  "svc_website-audit_label": "Auditoría web y informe SEO",
  "svc_website-audit_desc": "Análisis completo del sitio con recomendaciones",
  "svc_trading-consultation_label": "Consultas de trading",
  "svc_trading-consultation_desc": "Sesiones de estrategia de trading guiadas por expertos",
  "svc_managed-trading_label": "Trading gestionado",
  "svc_managed-trading_desc": "Trading gestionado por expertos con estrategias probadas",
  "svc_domain-management_label": "Gestión de dominios",
  "svc_domain-management_desc": "Registro de dominios, gestión DNS y transferencias",
  "svc_personal-branding_label": "Marca personal",
  "svc_personal-branding_desc": "Construye tu presencia en línea y marca personal",
  "admin_escalation_alert": "Escalación de chat",
  "admin_view_escalations": "Ver cola de escalaciones",
  "from": "Desde",
  "vector_gen_title": "Generador vectorial",
  "vector_gen_title_hl": "inteligente",
  "vector_gen_badge": "Estudio vectorial inteligente",
  "vector_gen_desc": "Describe tu idea, sube referencias y obtén un gráfico vectorial SVG listo para producción en segundos.",
  "vector_gen_balance": "Tu saldo",
  "vector_gen_per_gen": "créditos por generación",
  "vector_gen_prompt_label": "Describe tu gráfico vectorial",
  "vector_gen_prompt_ph": "ej. Un logo minimalista de montaña con rayos de sol, usando colores verde azulado y naranja...",
  "vector_gen_style": "Estilo",
  "vector_gen_color": "Modo de color",
  "vector_gen_refs": "Archivos de referencia",
  "vector_gen_optional": "opcional, máx. 3",
  "vector_gen_upload": "Subir referencia (PNG, JPG, SVG)",
  "vector_gen_generating": "Generando...",
  "vector_gen_cta": "Generar vector",
  "vector_gen_result": "Tu gráfico vectorial",
  "vector_gen_model_used": "Modelo",
  "vector_gen_history": "Historial de generación",
  "vector_gen_no_history": "Sin generaciones aún",
  "vector_gen_login_req": "Inicia sesión para usar el generador vectorial.",
  "vector_gen_service_title": "¿Necesitas vectores profesionales?",
  "vector_gen_service_desc": "Solicita gráficos vectoriales personalizados como servicio de diseño completo con revisiones y directrices de marca.",
  "vector_gen_service_cta": "Ver servicios de diseño",
  "vector_gen_product_type": "Tipo de producto",
  "vector_gen_size": "Tamaño de salida",
  "vector_gen_error_prompt": "Por favor describe tu idea de gráfico vectorial.",
  "admin_vector_gen": "Generador vectorial",
  "admin_showroom": "Showroom",
  "admin_landing_page": "Pagina de destino",
  "admin_landing_text": "Textos de pagina de destino",
  "admin_vector_title": "Generador vectorial",
  "admin_vector_models": "Modelos disponibles",
  "admin_vector_pricing": "Precios y límites",
  "svc_vector-generator_label": "Generador vectorial inteligente",
  "svc_vector-generator_desc": "Genera gráficos vectoriales SVG listos para producción a partir de descripciones de texto",
  "sp_vector_gen_name": "Generador vectorial inteligente",
  "sp_vector_gen_desc": "Genera gráficos vectoriales SVG listos para producción con tecnología inteligente.",
  "sp_vector_gen_feat": "Generación texto a vector|Exportación SVG y PNG|Múltiples estilos|Editor SVG inline|Subida de referencias|Precios por créditos",
  "sp_managed_hosting_name": "Hosting gestionado",
  "sp_managed_hosting_feat": "Monitoreo 24/7|Actualizaciones automáticas|Gestión SSL|Copias diarias|Optimización|Soporte dedicado",
  "sp_enterprise_ad_name": "Publicidad empresarial",
  "sp_enterprise_ad_feat": "Estrategia de campaña|Multi-canal|Pruebas A/B|Seguimiento|Gestor dedicado|Informes",
  "sp_email_marketing_name": "Configuración de email marketing",
  "sp_email_marketing_feat": "Secuencias de email|Diseño de plantillas|Automatización|Gestión de listas|Analítica|Pruebas A/B",
  "sp_competitor_analysis_name": "Informe de análisis competitivo",
  "sp_competitor_analysis_feat": "Análisis de mercado|Perfil competidores|SWOT|Comparación precios|Recomendaciones|Actualizaciones",
  "sp_website_audit_name": "Auditoría web y reporte SEO",
  "sp_website_audit_feat": "Auditoría técnica|Análisis SEO|Métricas|Accesibilidad|Escaneo seguridad|Plan de acción",
  "sp_defi_name": "Soluciones DeFi",
  "sp_defi_feat": "Contratos inteligentes|Yield farming|Pools de liquidez|Auditoría DeFi|Creación de tokens|Soluciones de staking",
  "sp_personal_brand_name": "Marca personal",
  "sp_personal_brand_feat": "Estrategia de marca|Presencia en redes sociales|Sitio web personal|Planificación de contenido|Fotos profesionales|Biografía",
  "sp_ad_gen_name": "Generador de anuncios",
  "sp_ad_gen_feat": "Textos publicitarios|Formatos creativos|Multi-plataforma|Variantes A/B|Segmentación|Consejos de rendimiento",
  "sp_priority_name": "Cola prioritaria",
  "sp_priority_feat": "Respuesta en 4 horas|Canal dedicado|Procesamiento prioritario|Actualizaciones de estado|Garantía SLA|Soporte extendido",
  "sp_maintenance_name": "Plan de mantenimiento",
  "sp_maintenance_feat": "Actualizaciones mensuales|Parches de seguridad|Monitoreo de rendimiento|Corrección de errores|Garantía de disponibilidad|Soporte prioritario",
  "sp_consulting_name": "Sesión de consultoría inteligente",
  "sp_consulting_feat": "Consulta experta|Sesión de estrategia|Asesoría técnica|Plan de implementación|Notas de seguimiento|Grabación incluida",
  "sp_market_snapshot_name": "Panorama de mercado",
  "sp_market_snapshot_feat": "Panorama del mercado|Tendencias clave|Panorama competitivo|Oportunidades de crecimiento|Factores de riesgo|Resumen ejecutivo",
  "sp_trend_explainer_name": "Explicador de tendencias",
  "sp_trend_explainer_feat": "Análisis de tendencias|Impacto industrial|Evaluación de oportunidades|Proyección temporal|Pasos de acción|Informe visual",
  "sp_competitor_qa_name": "Preguntas sobre competidores",
  "sp_competitor_qa_feat": "Análisis de estrategia|Información de precios|Posicionamiento|Comparación|Análisis de debilidades|Mapa de oportunidades",
  "sp_country_entry_name": "Verificación de entrada al mercado",
  "sp_country_entry_feat": "Preparación del mercado|Panorama regulatorio|Factores culturales|Análisis competitivo|Estrategia de entrada|Evaluación de riesgos",
  "sp_vendor_shortlist_name": "Lista corta de proveedores",
  "sp_vendor_shortlist_feat": "Investigación de proveedores|Matriz comparativa|Análisis de precios|Evaluación de capacidades|Recomendaciones|Datos de contacto",
  "sp_tam_logic_name": "Esquema lógico TAM",
  "sp_tam_logic_feat": "Estimación TAM|Desglose SAM/SOM|Marco lógico|Fuentes de datos|Supuestos de crecimiento|Presentación visual",
  "sp_positioning_name": "Ángulo de posicionamiento",
  "sp_positioning_feat": "Posicionamiento de mercado|Segmentación de audiencia|Propuesta de valor|Marco de mensajes|Diferenciación|Ventaja competitiva",
  "sp_managed_trading_name": "Trading gestionado",
  "sp_managed_trading_feat": "Gestión de cartera|Gestión de riesgos|Estrategias probadas|Informes regulares|Gestor dedicado|Análisis de mercado",
  "sp_trading_consult_name": "Consultoría de trading",
  "sp_trading_consult_feat": "Sesiones individuales|Desarrollo de estrategia|Análisis de mercado|Evaluación de riesgos|Revisión de cartera|Guía experta",
  "sp_domains_name": "Mercado de dominios LiveDomain",
  "sp_domains_feat": "Dominios premium|Ofertas aftermarket|Valoración de dominios|Soporte de transferencia|Negociación|Gestión de cartera",
  "sp_domain_mgmt_name": "Gestión de dominios",
  "sp_domain_mgmt_feat": "Gestión DNS|Auto-renovación|Soporte de transferencia|Seguimiento|Certificados SSL|Privacidad Whois",
  "vector_gen_model": "Modelo",
  "vector_gen_quality": "Nivel de calidad",
  "svc_smart-resume_label": "Generador inteligente de CV",
  "svc_smart-resume_desc": "CVs optimizados para ATS por nuestro sistema inteligente",
  "svc_smart-business-plan_label": "Generador inteligente de plan de negocios",
  "svc_smart-business-plan_desc": "Plan de negocios completo con finanzas y análisis de mercado",
  "svc_smart-seo-report_label": "Informe SEO inteligente",
  "svc_smart-seo-report_desc": "Análisis automatizado del sitio con recomendaciones accionables",
  "svc_smart-brand-kit_label": "Kit inteligente de logo y marca",
  "svc_smart-brand-kit_desc": "Concepto de logo, paleta de colores, tipografía y activos para redes sociales",
  "svc_smart-email-campaign_label": "Campaña de email inteligente",
  "svc_smart-email-campaign_desc": "Email marketing inteligente con secuencias optimizadas",
  "svc_smart-social-calendar_label": "Calendario y análisis de redes sociales",
  "svc_smart-social-calendar_desc": "30 días de publicaciones generadas con estrategia de engagement",
  "svc_ad-generator_label": "Generador de anuncios",
  "svc_ad-generator_desc": "Genera textos publicitarios de alta conversión al instante",
  "svc_smart-translation_label": "Servicios de traducción inteligente",
  "svc_smart-translation_desc": "Traducción profesional de documentos en más de 50 idiomas",
  "svc_smart-video-script_label": "Escritor inteligente de guiones de video",
  "svc_smart-video-script_desc": "Guiones para YouTube, TikTok y anuncios optimizados para engagement",
  "svc_priority-queue_label": "Cola prioritaria",
  "svc_priority-queue_desc": "Respuesta garantizada en 4 horas",
  "svc_maintenance-plan_label": "Plan de mantenimiento",
  "svc_maintenance-plan_desc": "Mantenimiento continuo, actualizaciones y soporte técnico",
  "svc_smart-consulting_label": "Sesión de consultoría inteligente",
  "svc_smart-consulting_desc": "Consultoría individual con nuestros expertos en tecnología",
  "svc_market-snapshot_label": "Panorama de mercado",
  "svc_market-snapshot_desc": "Visión rápida de su panorama de mercado",
  "svc_trend-explainer_label": "Explicador de tendencias",
  "svc_trend-explainer_desc": "Comprenda las tendencias emergentes de su industria",
  "svc_competitor-qa_label": "Preguntas sobre competidores",
  "svc_competitor-qa_desc": "Obtenga respuestas sobre las estrategias de sus competidores",
  "svc_country-entry-check_label": "Verificación de entrada al mercado",
  "svc_country-entry-check_desc": "Evalúe la preparación del mercado para expansión internacional",
  "svc_should-i-care_label": "Verificación de relevancia",
  "svc_should-i-care_desc": "Evalúe si una tendencia importa para su negocio",
  "svc_report-matchmaker_label": "Buscador de informes",
  "svc_report-matchmaker_desc": "Encuentre el informe de investigación adecuado",
  "svc_which-region-first_label": "Prioridad regional",
  "svc_which-region-first_desc": "Orientación basada en datos para entrada al mercado regional",
  "svc_vendor-shortlist_label": "Lista corta de proveedores",
  "svc_vendor-shortlist_desc": "Lista curada de proveedores para sus necesidades",
  "svc_forecast-explanation_label": "Explicación de pronóstico",
  "svc_forecast-explanation_desc": "Explicación clara de pronósticos de mercado",
  "svc_outreach-email-gen_label": "Generador de emails de contacto",
  "svc_outreach-email-gen_desc": "Genere emails de contacto personalizados a escala",
  "svc_executive-summary_label": "Resumen ejecutivo",
  "svc_executive-summary_desc": "Resúmenes listos para presentaciones",
  "svc_faq-answer-draft_label": "Borrador de respuestas FAQ",
  "svc_faq-answer-draft_desc": "Borrador de respuestas a preguntas frecuentes",
  "svc_jtbd-problem_label": "Declaración de problema JTBD",
  "svc_jtbd-problem_desc": "Análisis de problema con framework JTBD",
  "svc_tam-logic-sketch_label": "Esquema lógico TAM",
  "svc_tam-logic-sketch_desc": "Estimación del mercado total con desglose lógico",
  "svc_risk-checklist_label": "Lista de verificación de riesgos",
  "svc_risk-checklist_desc": "Lista de verificación integral de evaluación de riesgos",
  "svc_feature-prioritization_label": "Priorización de funciones",
  "svc_feature-prioritization_desc": "Recomendaciones de priorización basadas en datos",
  "svc_next-research-question_label": "Próxima pregunta de investigación",
  "svc_next-research-question_desc": "Descubra la próxima pregunta de investigación crítica",
  "svc_positioning-angle_label": "Ángulo de posicionamiento",
  "svc_positioning-angle_desc": "Análisis de posicionamiento de producto y audiencia",
  "svc_blog-outline-trend_label": "Esquema de blog desde tendencia",
  "svc_blog-outline-trend_desc": "Convierta temas trending en esquemas de blog estructurados",
  "admin_ai_reports": "Informes de servicios IA",
  "admin_project_delivery": "Entrega de proyecto",
  "admin_analytics_digest": "[TRANSLATE] Analytics Digest",
  "admin_seo_suggestions": "[TRANSLATE] SEO Optimization",
  "admin_visitor_map": "[TRANSLATE] Visitor Map",
  "admin_competitor_monitor": "[TRANSLATE] Competitor Intelligence",
  "admin_email_workflows": "[TRANSLATE] Email Workflows",
  "admin_collab_editing": "[TRANSLATE] Team Collaboration",
  "admin_status_online": "[TRANSLATE] Online",
  "admin_status_offline": "[TRANSLATE] Offline",
  "admin_status_online_desc": "[TRANSLATE] You are visible as online. Users requesting escalation will be connected to you.",
  "admin_status_offline_desc": "[TRANSLATE] You are offline. Users requesting escalation will see a message to try later.",
  "admin_ai_model": "[TRANSLATE] AI Model",
  "admin_prompts": "[TRANSLATE] Prompts",
  "admin_no_escalations": "[TRANSLATE] No escalations in queue.",
  "blog_edit": "[TRANSLATE] Edit Post",
  "admin_card_visibility": "[TRANSLATE] Card Visibility",
  "agency_rista_tooltip": "Chatea con RisTA",
  "agency_hero_title_1": "Sitios web ultrarrápidos que ",
  "agency_hero_title_highlight": "venden",
  "agency_hero_title_2": " para negocios locales",
  "agency_hero_subtitle_1": "Obtén un sitio personalizado que carga en milisegundos + analíticas integradas por",
  "agency_hero_subtitle_2": ". Sin páginas lentas, más leads — lanzamiento en semanas.",
  "agency_hero_limited": "¡Plazas limitadas!",
  "agency_hero_cta_pricing": "Ver paquete de €498",
  "agency_hero_cta_audit": "Auditoría gratuita",
  "agency_trust_maintenance": "mantenimiento después",
  "agency_trust_efficient": "100% Eficiente",
  "agency_trust_powered": "Impulsado por Sistema Inteligente",
  "agency_speed_title": "Velocidad de carga del sitio",
  "agency_speed_before": "Antes",
  "agency_speed_after": "Después",
  "agency_speed_leads": "+35% leads",
  "agency_pain_title_1": "Los sitios lentos ",
  "agency_pain_title_2": "matan las ventas",
  "agency_pain_subtitle": "Cada segundo que tarda tu sitio en cargar, pierdes clientes. Aquí está el problema — y cómo lo solucionamos.",
  "agency_pain_slow_title": "Carga lenta = Leads perdidos",
  "agency_pain_slow_desc": "Tu sitio web tarda más de 5 segundos en cargar. Los visitantes se van antes de ver tu oferta. Estás pagando por tráfico que nunca convierte.",
  "agency_pain_stats_title": "47% se va si >3s",
  "agency_pain_stats_desc": "La investigación de Google muestra que casi la mitad de los visitantes abandonan un sitio móvil que tarda más de 3 segundos en cargar.",
  "agency_pain_stats_source": "Fuente: Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "Nuestra tecnología Speed-First",
  "agency_pain_solution_desc": "Sitios personalizados optimizados para cargar en menos de 1 segundo. Cache en edge, imágenes optimizadas, código minimizado.",
  "agency_pricing_title": "Precios simples y transparentes",
  "agency_pricing_subtitle": "Elige el plan que se adapte a tu negocio. Todos los planes incluyen nuestra tecnología Speed-First.",
  "agency_pricing_urgency_1": "Solo quedan ",
  "agency_pricing_urgency_2": " plazas starter este mes",
  "agency_pricing_popular": "MÁS POPULAR",
  "agency_pricing_get_started": "Comenzar",
  "agency_pricing_guarantee": "Garantía de devolución de 30 días",
  "agency_pricing_ideal": "Ideal para:",
  "agency_pricing_starter": "Starter",
  "agency_pricing_onetime": "único pago",
  "agency_pricing_starter_ideal": "Emprendedores",
  "agency_pricing_s_1": "Sitio web personalizado ultrarrápido",
  "agency_pricing_s_2": "Dominio + hosting por 1 año",
  "agency_pricing_s_3": "Panel de analíticas básico",
  "agency_pricing_s_4": "Diseño responsive para móviles",
  "agency_pricing_s_5": "Certificado SSL incluido",
  "agency_pricing_performance": "Performance",
  "agency_pricing_perf_ideal": "Tiendas en crecimiento",
  "agency_pricing_p_1": "Todo lo de Starter",
  "agency_pricing_p_2": "E-commerce + recuperación de carrito",
  "agency_pricing_p_3": "Paquete de optimización SEO",
  "agency_pricing_p_4": "Integración de pruebas A/B",
  "agency_pricing_p_5": "Soporte prioritario",
  "agency_pricing_premium": "Premium",
  "agency_pricing_prem_ideal": "Negocios en expansión",
  "agency_pricing_pr_1": "Todo lo de Performance",
  "agency_pricing_pr_2": "Gestión de Google Ads",
  "agency_pricing_pr_3": "Auditorías semanales de rendimiento",
  "agency_pricing_pr_4": "Gestor de cuenta dedicado",
  "agency_pricing_pr_5": "Integraciones personalizadas",
  "agency_social_title": "Confianza de negocios locales",
  "agency_social_rista_label": "RisTA AI:",
  "agency_social_rista_quote": "Analizo el comportamiento de los visitantes en tiempo real para mejorar tus conversiones.",
  "agency_social_see_clients": "Lo que dicen nuestros clientes",
  "agency_social_t1_name": "Marko K.",
  "agency_social_t1_role": "CEO, Tienda local",
  "agency_social_t1_text": "¡Duplicamos nuestros leads en el primer mes! El sitio carga al instante y a nuestros clientes les encanta el nuevo diseño.",
  "agency_social_t2_name": "Elena V.",
  "agency_social_t2_role": "Propietaria de restaurante",
  "agency_social_t2_text": "Nuestros pedidos online aumentaron un 40% después del lanzamiento. La diferencia de velocidad es abismal.",
  "agency_social_t3_name": "Thomas H.",
  "agency_social_t3_role": "Estudio de fitness",
  "agency_social_t3_text": "Profesional, rápido y realmente cumplen sus promesas. Nuestra tasa de reservas subió un 35% en solo 3 semanas.",
  "agency_social_t4_name": "Ana S.",
  "agency_social_t4_role": "Propietaria de boutique",
  "agency_social_t4_text": "La configuración del e-commerce fue perfecta. La recuperación de carrito sola pagó el plan Performance en el primer trimestre.",
  "agency_social_metric_1": "Tiempo medio de carga",
  "agency_social_metric_2": "Más leads",
  "agency_social_metric_3": "Satisfacción del cliente",
  "agency_services_title": "Todo lo que tu negocio necesita",
  "agency_services_subtitle": "Soluciones digitales integrales para hacer crecer tu presencia online.",
  "agency_svc_fast_title": "Sitios web rápidos",
  "agency_svc_fast_desc": "Sitios personalizados que cargan en menos de 1 segundo. Mobile-first, optimizados para SEO.",
  "agency_svc_ecom_title": "Tiendas E-Commerce",
  "agency_svc_ecom_desc": "Vende online con recuperación de carrito, procesamiento de pagos y gestión de inventario.",
  "agency_svc_seo_title": "Auditoría SEO y optimización",
  "agency_svc_seo_desc": "Posiciónate más alto en Google. SEO técnico, estrategia de contenido e informes mensuales.",
  "agency_svc_ads_title": "Configuración de Google Ads",
  "agency_svc_ads_desc": "Obtén tráfico dirigido rápidamente. Configuración de campaña, optimización y seguimiento de ROI incluido.",
  "agency_svc_maint_title": "Mantenimiento y soporte",
  "agency_svc_maint_desc": "Hosting, actualizaciones de seguridad, copias de seguridad y cambios de contenido. Desde €30/mes.",
  "agency_faq_title": "Preguntas frecuentes",
  "agency_faq_q1": "¿Qué tan rápido cargará mi sitio web?",
  "agency_faq_a1": "Menos de 1 segundo. Optimizamos cada milisegundo — desde la respuesta del servidor hasta el renderizado visual completo.",
  "agency_faq_q2": "¿Qué incluye el paquete Starter de €498?",
  "agency_faq_a2": "Un sitio web ultrarrápido personalizado, dominio y hosting por 1 año, panel de analíticas básico, diseño responsive y certificado SSL.",
  "agency_faq_q3": "¿Cuánto tiempo tarda el lanzamiento?",
  "agency_faq_a3": "La mayoría de los proyectos Starter se lanzan en 2-3 semanas. Los planes Performance y Premium suelen tardar 4-6 semanas.",
  "agency_faq_q4": "¿Ofrecen mantenimiento continuo?",
  "agency_faq_a4": "Sí. Después del primer año, el mantenimiento comienza en €30/mes, incluyendo hosting, actualizaciones de seguridad y cambios menores.",
  "agency_faq_q5": "¿Puedo actualizar mi plan más adelante?",
  "agency_faq_a5": "Por supuesto. Puedes actualizar de Starter a Performance o Premium en cualquier momento. Acreditaremos tu inversión inicial.",
  "agency_cta_title_1": "¿Listo para escalar ",
  "agency_cta_title_2": "sin límites?",
  "agency_cta_subtitle": "Cuéntanos sobre tu negocio y crearemos un plan personalizado para hacer crecer tu presencia online. Consulta gratuita, sin compromiso.",
  "agency_contact_name": "Tu nombre",
  "agency_contact_email": "Correo electrónico",
  "agency_contact_biz_select": "Selecciona tipo de negocio",
  "agency_contact_biz_restaurant": "Restaurante / Comida",
  "agency_contact_biz_retail": "Comercio / Tienda",
  "agency_contact_biz_services": "Servicios profesionales",
  "agency_contact_biz_fitness": "Fitness / Bienestar",
  "agency_contact_biz_realestate": "Bienes raíces",
  "agency_contact_biz_other": "Otro",
  "agency_contact_submit": "Obtener consulta gratuita",
  "agency_contact_sent_title": "¡Mensaje enviado!",
  "agency_contact_sent_desc": "Te responderemos en 24 horas.",
  "agency_exit_title": "¡Espera! ¿Auditoría de velocidad gratis?",
  "agency_exit_desc": "Descubre cuánto más rápido podría ser tu sitio web. Obtén un informe detallado de rendimiento — 100% gratis.",
  "agency_exit_email": "Tu correo",
  "agency_exit_submit": "Enviar auditoría",
  "agency_exit_thanks_title": "¡Gracias!",
  "agency_exit_thanks_desc": "Te enviaremos tu auditoría de velocidad gratuita en 24 horas.",
  "agency_footer_brand_desc": "Desarrollado, alojado y diseñado por Infinitybusiness.org",
  "agency_footer_services": "Servicios",
  "agency_footer_fast_web": "Sitios web rápidos",
  "agency_footer_ecom": "Tiendas E-Commerce",
  "agency_footer_seo": "Auditoría SEO",
  "agency_footer_ads": "Configuración Google Ads",
  "agency_footer_maint": "Mantenimiento",
  "agency_footer_company": "Empresa",
  "agency_footer_about": "Sobre nosotros",
  "agency_footer_contact": "Contacto",
  "agency_footer_privacy": "Política de privacidad",
  "agency_footer_terms": "Términos y condiciones",
  "agency_footer_touch": "Contáctanos",
  "agency_footer_copyright": "© 2026 Infinity Business. Todos los derechos reservados.",
  "agency_footer_dev_by": "Desarrollado, alojado y diseñado por",
  "agency_footer_newsletter": "Suscríbete al boletín",
  "agency_footer_subscribe": "Suscribirse",
  "agency_sticky_pricing": "Ver precios",
  "showroom_page_title": "Showroom",
  "showroom_meta_desc": "Explore nuestro portafolio de transformaciones web. Comparaciones antes y despues de proyectos reales de clientes.",
  "showroom_badge": "Nuestro Trabajo",
  "showroom_title_prefix": "Proyecto",
  "showroom_title_highlight": "Showroom",
  "showroom_subtitle": "Vea transformaciones reales. Arrastre el control deslizante para comparar los estados antes y despues de nuestros proyectos.",
  "showroom_search_placeholder": "Buscar proyectos...",
  "showroom_all_services": "Todos los Servicios",
  "showroom_sort_newest": "Mas recientes",
  "showroom_sort_oldest": "Mas antiguos",
  "showroom_sort_name_az": "Nombre A-Z",
  "showroom_sort_name_za": "Nombre Z-A",
  "showroom_active_filters": "Filtros activos",
  "showroom_showing": "Mostrando",
  "showroom_project_singular": "proyecto",
  "showroom_project_plural": "proyectos",
  "showroom_empty": "Aun no hay proyectos en el showroom.",
  "showroom_no_match": "Ningun proyecto coincide con sus filtros.",
  "showroom_features_built": "Funciones Creadas",
  "showroom_visit_live": "Visitar Sitio en Vivo"
};
